// Lao mirror of en.ts. Empty strings (`""`) and missing keys both fall back
// to en at runtime via t() — see i18n/index.ts. Keys flagged with TODO_LO are
// not yet confidently translated; the shop owner (native speaker) will sweep
// these in a follow-up pass.
const lo = {
    // ---------- Bulk import / Add many (page bodies) ----------
    "bulkImport.title": "ນຳເຂົ້າຈຳນວນຫຼາຍ",
    "bulkImport.subtitle": "ສ້າງສິນຄ້າ, ຫົວໜ່ວຍ, ໝວດໝູ່, ຍີ່ຫໍ້ ແລະ ສາງ ຈາກໄຟລ໌ Excel ດຽວ.",
    "bulkImport.downloadTemplate": "ດາວໂຫລດແບບຟອມ",
    "bulkImport.downloadCatalog": "ດາວໂຫລດລາຍການສິນຄ້າປັດຈຸບັນ",
    "bulkImport.working": "ກຳລັງດຳເນີນການ…",
    "bulkImport.preview": "ເບິ່ງຕົວຢ່າງ",
    "bulkImport.stockTip": "ເຄັດລັບ: ຊີດ Stock ບໍ່ສາມາດເຮັດຊ້ຳໄດ້ — ຫຼັງຈາກ Apply ສຳເລັດແລ້ວ, ໃຫ້ລ້າງມັນ ຫຼື ໃຊ້ການ set.",
    "bulkImport.previewSaved": "ເບິ່ງຕົວຢ່າງ (ຍັງບໍ່ໄດ້ບັນທຶກ)",
    "bulkImport.applied": "ນຳໃຊ້ແລ້ວ",
    "bulkImport.errorsWord": "ຂໍ້ຜິດພາດ",
    "bulkImport.sumProducts": "ສິນຄ້າ",
    "bulkImport.newWord": "ໃໝ່",
    "bulkImport.updatedWord": "ອັບເດດ",
    "bulkImport.sumUnits": "ຫົວໜ່ວຍ",
    "bulkImport.sumBarcodes": "ບາໂຄດທີ່ສ້າງ",
    "bulkImport.barcodesWord": "ບາໂຄດ",
    "bulkImport.sumCategories": "ໝວດໝູ່",
    "bulkImport.sumBrands": "ຍີ່ຫໍ້",
    "bulkImport.sumSuppliers": "ຜູ້ສະໜອງ",
    "bulkImport.sumStockMoves": "ການເຄື່ອນໄຫວສາງ",
    "bulkImport.colSheet": "ຊີດ",
    "bulkImport.colRow": "ແຖວ",
    "bulkImport.colProblem": "ບັນຫາ",
    "addMany.title": "ເພີ່ມສິນຄ້າຫຼາຍລາຍການ",
    "addMany.subtitle": "ພິມ ຫຼື ວາງແຖວຈາກ Excel ໂດຍກົງ, ແລ້ວ ເບິ່ງຕົວຢ່າງ → ນຳໃຊ້.",
    "addMany.addRows": "ເພີ່ມແຖວ",
    "addMany.firstRow": "ທຳອິດ: ແຖວ",
    // ---------- Navigation (section titles) ----------
    "nav.till": "ໜ້າຂາຍ",
    "nav.overview": "ພາບລວມ",
    "nav.salesMoney": "ການຂາຍ ແລະ ເງິນ",
    "nav.catalog": "ລາຍການສິນຄ້າ",
    "nav.inventory": "ສາງສິນຄ້າ",
    "nav.admin": "ຜູ້ດູແລ",
    "nav.shop": "ການດໍາເນີນງານຮ້ານ",
    "nav.posSection": "ໜ້າຂາຍ",
    // ---------- Navigation (per-item labels) ----------
    "navItem.pos": "ໜ້າຂາຍ",
    "navItem.held": "ບິນທີ່ຄ້າງໄວ້",
    "navItem.recent": "ການຂາຍຫຼ້າສຸດ",
    "navItem.quotes": "ໃບສະເໜີລາຄາ",
    "navItem.shift": "ຮອບວຽກ",
    "navItem.tillSettings": "ການຕັ້ງຄ່າໜ້າຂາຍ",
    "navItem.dashboard": "ພາບລວມ",
    "navItem.sales": "ປະຫວັດການຂາຍ",
    "navItem.conflicts": "ກວດການຂາຍ",
    "navItem.shifts": "ຮອບວຽກ ແລະ ລິ້ນຊັກ",
    "navItem.expenses": "ລາຍຈ່າຍ",
    "navItem.syncQueue": "ຄິວຊິ້ງຂໍ້ມູນ",
    "navItem.products": "ສິນຄ້າ",
    "navItem.bulkImport": "ນຳເຂົ້າຈຳນວນຫຼາຍ",
    "navItem.addMany": "ເພີ່ມສິນຄ້າຫຼາຍລາຍການ",
    "navItem.catbrand": "ໝວດໝູ່ ແລະ ຍີ່ຫໍ້",
    "navItem.promotions": "ໂປຣໂມຊັ່ນ",
    "navItem.customers": "ລູກຄ້າ",
    "navItem.suppliers": "ຜູ້ສະໜອງ",
    "navItem.stock": "ສາງຕາມຮ້ານ",
    "navItem.receive": "ຮັບສິນຄ້າ",
    "navItem.movements": "ການເຄື່ອນໄຫວສາງ",
    "navItem.transfers": "ການໂອນສິນຄ້າ",
    "navItem.count": "ກວດນັບສາງ",
    "navItem.staff": "ພະນັກງານ",
    "navItem.stores": "ຮ້ານ",
    "navItem.reports": "ລາຍງານ",
    "navItem.settings": "ການຕັ້ງຄ່າທົ່ວໄປ",
    "navItem.audit": "ບັນທຶກກວດສອບ",
    // ---------- Topbar ----------
    // TODO_LO: Alerts on
    "topbar.alertsOn": "ການແຈ້ງເຕືອນເປີດ",
    // TODO_LO: Alerts blocked
    "topbar.alertsBlocked": "ການແຈ້ງເຕືອນຖືກບລັອກ",
    // TODO_LO: Alerts n/a
    "topbar.alertsUnavailable": "ການແຈ້ງເຕືອນບໍ່ສາມາດໃຊ້ໄດ້",
    // TODO_LO: Enable alerts
    "topbar.enableAlerts": "ເປີດການແຈ້ງເຕືອນ",
    // TODO_LO: Install
    "topbar.install": "ຕິດຕັ້ງ",
    "topbar.store": "ຮ້ານ",
    // TODO_LO: Active store
    "topbar.activeStore": "ຮ້ານທີ່ໃຊ້ງານ",
    // TODO_LO: — Select store —
    "topbar.selectStore": "— ເລືອກຮ້ານ —",
    // TODO_LO: Close the active shift before switching stores.
    "topbar.shiftBlocksStoreSwitch": "ປິດຮອບວຽກກ່ອນປ່ຽນຮ້ານ.",
    "topbar.online": "ອອນລາຍ",
    "topbar.offline": "ອອບລາຍ",
    "topbar.shiftOpen": "ຮອບວຽກເປີດ",
    "topbar.noShift": "ບໍ່ມີຮອບວຽກ",
    "topbar.printerReady": "ເຄື່ອງພິມພ້ອມ",
    "topbar.printerNotSet": "ຍັງບໍ່ໄດ້ຕັ້ງເຄື່ອງພິມ",
    "topbar.battery": "ແບັດເຕີຣີ",
    // ---------- App updates (confirm-update flow) ----------
    // TODO_LO: Check for updates
    "update.checkNow": "ກວດຫາການອັບເດດ",
    // TODO_LO: Checking…
    "update.checking": "ກໍາລັງກວດ…",
    // TODO_LO: Up to date
    "update.upToDate": "ເປັນເວີຊັນລ່າສຸດ",
    // TODO_LO: Update available
    "update.available": "ມີການອັບເດດໃໝ່",
    // TODO_LO: Download update
    "update.download": "ດາວໂຫລດການອັບເດດ",
    // TODO_LO: Downloading
    "update.downloading": "ກໍາລັງດາວໂຫລດ",
    // TODO_LO: Update downloaded
    "update.downloaded": "ດາວໂຫລດແລ້ວ",
    // TODO_LO: Restart to install
    "update.restartToInstall": "ເລີ່ມໃໝ່ເພື່ອຕິດຕັ້ງ",
    // TODO_LO: Update failed — retry
    "update.errorRetry": "ການອັບເດດລົ້ມເຫລວ — ລອງໃໝ່",
    // TODO_LO: Release notes
    "update.releaseNotes": "ບັນທຶກການອັບເດດ",
    // TODO_LO: Released
    "update.released": "ປ່ອຍວັນທີ",
    // TODO_LO: No release notes for this version.
    "update.noNotes": "ບໍ່ມີຫມາຍເຫດສຳລັບເວີຊັນນີ້.",
    // ---------- Common ----------
    "common.walkIn": "ລູກຄ້າທົ່ວໄປ",
    "common.offline": "ອອບລາຍ",
    "common.online": "ອອນລາຍ",
    "common.loading": "ກໍາລັງໂຫລດ…",
    "common.save": "ບັນທຶກ",
    "common.cancel": "ຍົກເລີກ",
    "common.confirm": "ຢືນຢັນ",
    "common.close": "ປິດ",
    "common.search": "ຄົ້ນຫາ",
    "common.export": "ສົ່ງອອກ",
    "common.import": "ນໍາເຂົ້າ",
    // TODO_LO: Reprint
    "common.reprint": "ພິມຄືນ",
    // TODO_LO: Void
    "common.void": "ຍົກເລີກບິນ",
    "common.delete": "ລຶບ",
    "common.edit": "ແກ້ໄຂ",
    "common.add": "ເພີ່ມ",
    "common.view": "ເບິ່ງ",
    "common.filter": "ກັ່ນຕອງ",
    // TODO_LO: Apply
    "common.apply": "ນຳໃຊ້",
    // TODO_LO: Reset
    "common.reset": "ຕັ້ງຄືນ",
    // TODO_LO: Clear
    "common.clear": "ລ້າງ",
    "common.all": "ທັງໝົດ",
    "common.none": "ບໍ່ມີ",
    "common.yes": "ແມ່ນ",
    "common.no": "ບໍ່",
    "common.signOut": "ອອກຈາກລະບົບ",
    "common.signIn": "ເຂົ້າສູ່ລະບົບ",
    "common.back": "ກັບ",
    "common.next": "ຕໍ່ໄປ",
    "common.previous": "ກ່ອນໜ້າ",
    // TODO_LO: Submit
    "common.submit": "ສົ່ງ",
    // TODO_LO: Retry
    "common.retry": "ລອງໃໝ່",
    // TODO_LO: Refresh
    "common.refresh": "ໂຫລດຄືນ",
    "common.print": "ພິມ",
    // TODO_LO: Download
    "common.download": "ດາວໂຫລດ",
    // TODO_LO: Upload
    "common.upload": "ອັບໂຫລດ",
    // TODO_LO: Copy
    "common.copy": "ສຳເນົາ",
    // TODO_LO: Paste
    "common.paste": "ວາງ",
    // TODO_LO: Not set
    "common.notSet": "ບໍ່ໄດ້ຕັ້ງ",
    "common.never": "ບໍ່ເຄີຍ",
    // TODO_LO: Optional
    "common.optional": "ບໍ່ບັງຄັບ",
    // TODO_LO: Required
    "common.required": "ຈຳເປັນ",
    // TODO_LO: Actions
    "common.actions": "ການກະທຳ",
    // TODO_LO: Status
    "common.status": "ສະຖານະ",
    "common.name": "ຊື່",
    "common.amount": "ຈໍານວນເງິນ",
    "common.date": "ວັນທີ",
    "common.time": "ເວລາ",
    "common.notes": "ບັນທຶກ",
    "common.note": "ບັນທຶກ",
    "common.total": "ລວມທັງໝົດ",
    // TODO_LO: Subtotal
    "common.subtotal": "ລວມຍ່ອຍ",
    "common.discount": "ສ່ວນຫຼຸດ",
    // TODO_LO: Tax
    "common.tax": "ພາສີ",
    "common.qty": "ຈໍານວນ",
    "common.price": "ລາຄາ",
    // TODO_LO: Cost
    "common.cost": "ຕົ້ນທຶນ",
    "common.sku": "SKU",
    // TODO_LO: Barcode
    "common.barcode": "ບາໂຄດ",
    "common.category": "ໝວດໝູ່",
    // TODO_LO: Brand
    "common.brand": "ຍີ່ຫໍ້",
    // TODO_LO: Supplier
    "common.supplier": "ຜູ້ສະໜອງ",
    "common.store": "ຮ້ານ",
    // TODO_LO: Cashier
    "common.cashier": "ພະນັກງານເກັບເງິນ",
    "common.customer": "ລູກຄ້າ",
    "common.product": "ສິນຄ້າ",
    // TODO_LO: Email
    "common.email": "ອີເມວ",
    "common.phone": "ໂທ",
    "common.password": "ລະຫັດຜ່ານ",
    // TODO_LO: Role
    "common.role": "ບົດບາດ",
    // TODO_LO: Active
    "common.active": "ໃຊ້ງານ",
    // TODO_LO: Inactive
    "common.inactive": "ບໍ່ໃຊ້ງານ",
    // TODO_LO: Enabled
    "common.enabled": "ເປີດໃຊ້",
    // TODO_LO: Disabled
    "common.disabled": "ປິດໃຊ້",
    // TODO_LO: Empty
    "common.empty": "ວ່າງເປົ່າ",
    // TODO_LO: No results
    "common.noResults": "ບໍ່ພົບຜົນລັບ",
    // TODO_LO: All stores
    "common.allStores": "ທຸກຮ້ານ",
    // TODO_LO: All cashiers
    "common.allCashiers": "ພະນັກງານທັງໝົດ",
    // TODO_LO: All categories
    "common.allCategories": "ໝວດໝູ່ທັງໝົດ",
    // TODO_LO: All brands
    "common.allBrands": "ຍີ່ຫໍ້ທັງໝົດ",
    // TODO_LO: All suppliers
    "common.allSuppliers": "ຜູ້ສະໜອງທັງໝົດ",
    // TODO_LO: All statuses
    "common.allStatuses": "ສະຖານະທັງໝົດ",
    // TODO_LO: All customers
    "common.allCustomers": "ລູກຄ້າທັງໝົດ",
    // TODO_LO: An error occurred
    "common.errorOccurred": "ເກີດຂໍ້ຜິດພາດ",
    // TODO_LO: Try again
    "common.tryAgain": "ລອງໃໝ່ອີກຄັ້ງ",
    // ---------- POS ----------
    "pos.scanPlaceholder": "ສະແກນບາໂຄດ ຫຼື ຄົ້ນຫາຕາມຊື່…",
    "pos.cartEmpty": "ກະຕ່າວ່າງເປົ່າ. ສະແກນ ຫຼື ກົດສິນຄ້າເພື່ອເລີ່ມຕົ້ນ.",
    "pos.noProductsMatch": "ບໍ່ພົບສິນຄ້າທີ່ກົງກັນ.",
    "pos.barcodeMatch": "ກົງກັບບາໂຄດ — ແຕະເພື່ອເພີ່ມຂະໜາດນີ້",
    "pos.payCash": "ເງິນສົດ",
    "pos.payQr": "QR / ໂອນ",
    "pos.split": "ແບ່ງຈ່າຍ",
    "pos.credit": "ເຄຣດິດ",
    "pos.hold": "ຄ້າງໄວ້",
    "pos.recall": "ເອີ້ນຄືນ",
    "pos.discount": "ສ່ວນຫຼຸດ",
    "pos.redeem": "ແລກ",
    "pos.payLabel": "ຈ່າຍ",
    "pos.clearCart": "ລ້າງກະຕ່າ",
    "pos.attachCustomer": "ຕິດແທັກ",
    "pos.changeCustomer": "ປ່ຽນ",
    "pos.itemsLine": "ລາຍການ",
    "pos.lineSingular": "ລາຍການ",
    "pos.linePlural": "ລາຍການ",
    "pos.points": "pts",
    "pos.tab": "ແທັບ",
    "pos.allCategories": "ທັງໝົດ",
    "pos.payTotalLabel": "ຈ່າຍ",
    // ---------- Customer lookup ----------
    // All TODO_LO until owner sweep — left empty so they fall back to en.
    "customerLookup.title": "ຄົ້ນຫາລູກຄ້າ",
    "customerLookup.searchPlaceholder": "ຄົ້ນຫາຕາມຊື່ ຫຼື ເບີໂທ…",
    "customerLookup.attach": "ຕິດແທັກລູກຄ້າ",
    "customerLookup.detach": "ຍົກເລີກການຕິດແທັກ",
    "customerLookup.create": "ສ້າງລູກຄ້າໃໝ່",
    "customerLookup.namePlaceholder": "ຊື່ລູກຄ້າ",
    "customerLookup.phonePlaceholder": "ເບີໂທ",
    "customerLookup.emailPlaceholder": "ອີເມວ",
    "customerLookup.notesPlaceholder": "ບັນທຶກ",
    "heldOrders.title": "ຄຳສັ່ງຊື້ທີ່ຄ້າງໄວ້",
    "heldOrders.empty": "ບໍ່ມີຄຳສັ່ງຊື້ທີ່ຄ້າງໄວ້",
    "heldOrders.resume": "ສືບຕໍ່",
    "heldOrders.discard": "ຖິ້ມ",
    "loyalty.title": "ຄະແນນສະສົມ",
    "loyalty.available": "ຄະແນນທີ່ໃຊ້ໄດ້",
    "loyalty.redeemAmount": "ຈຳນວນຄະແນນທີ່ແລກ",
    "loyalty.discountValue": "ມູນຄ່າສ່ວນຫຼຸດ",
    "loyalty.confirm": "ຢືນຢັນການແລກ",
    "credit.title": "ການຂາຍເຄຣດິດ",
    "credit.outstanding": "ຍອດຄ້າງຊຳລະ",
    "credit.creditLimit": "ວົງເງິນເຄຣດິດ",
    "credit.afterSale": "ຍອດຫຼັງຂາຍ",
    "credit.offlineBlocked": "ການຂາຍເຄຣດິດຖືກບລັອກໃນໂໝດອອບລາຍ",
    "credit.confirm": "ຢືນຢັນການຂາຍເຄຣດິດ",
    "split.title": "ແບ່ງການຈ່າຍເງິນ",
    "split.addLine": "ເພີ່ມລາຍການ",
    "split.removeLine": "ລຶບລາຍການ",
    "split.method": "ວິທີການຈ່າຍ",
    "split.amount": "ຈຳນວນເງິນ",
    "split.balance": "ຍອດຄົງເຫຼືອ",
    "split.confirm": "ຢືນຢັນ",
    // ---------- POS · Cash confirmation modal ----------
    // TODO_LO: Confirm cash payment
    "cashPay.title": "ຢືນຢັນການຈ່າຍເງິນສົດ",
    // TODO_LO: Sale total
    "cashPay.saleTotal": "ຍອດລວມການຂາຍ",
    // TODO_LO: Cash tendered
    "cashPay.tendered": "ເງິນສົດທີ່ໄດ້ຮັບ",
    // TODO_LO: Exact
    "cashPay.exact": "ຄົບຖ້ວນ",
    // TODO_LO: Short
    "cashPay.short": "ຍັງຂາດ",
    // TODO_LO: Change due
    "cashPay.changeDue": "ເງິນທອນ",
    // TODO_LO: Tendered amount must be at least the sale total. Press Enter to confirm.
    "cashPay.hint": "ຈຳນວນເງິນທີ່ໄດ້ຮັບຕ້ອງຫຼາຍກວ່າ ຫຼື ເທົ່າກັບຍອດລວມ. ກົດ Enter ເພື່ອຢືນຢັນ.",
    // TODO_LO: Confirm cash sale
    "cashPay.confirm": "ຢືນຢັນການຂາຍເງິນສົດ",
    // ---------- POS · No-sale / open drawer ----------
    // TODO_LO: Open drawer
    "noSale.openDrawer": "ເປີດລິ້ນຊັກ",
    // TODO_LO: Open cash drawer
    "noSale.title": "ເປີດລິ້ນຊັກເງິນ",
    // TODO_LO: Opening the drawer without a sale...
    "noSale.intro": "ເປີດລິ້ນຊັກໂດຍບໍ່ມີການຂາຍ. ເລືອກເຫດຜົນ — ຈະຖືກບັນທຶກໄວ້ໃຫ້ຜູ້ຈັດການກວດສອບ.",
    // TODO_LO: Reason
    "noSale.reasonLabel": "ເຫດຜົນ",
    // TODO_LO: Note (optional)
    "noSale.noteLabel": "ໝາຍເຫດ (ບໍ່ບັງຄັບ)",
    // TODO_LO: Add detail if helpful
    "noSale.notePlaceholder": "ເພີ່ມລາຍລະອຽດຖ້າຈຳເປັນ",
    // TODO_LO: Open drawer
    "noSale.confirm": "ເປີດລິ້ນຊັກ",
    // TODO_LO: Make change
    "noSale.reasonMakeChange": "ແລກເງິນ",
    // TODO_LO: Remove cash
    "noSale.reasonRemoveCash": "ເອົາເງິນອອກ",
    // TODO_LO: Wrong amount
    "noSale.reasonWrongAmount": "ຈຳນວນຜິດ",
    // TODO_LO: Customer refund
    "noSale.reasonCustomerRefund": "ຄືນເງິນລູກຄ້າ",
    // TODO_LO: Other
    "noSale.reasonOther": "ອື່ນໆ",
    // ---------- POS · QR / Bank-transfer confirmation modal ----------
    // TODO_LO: Confirm QR / Transfer payment
    "qrPay.title": "ຢືນຢັນການຈ່າຍ QR / ໂອນ",
    // TODO_LO: Sale total
    "qrPay.saleTotal": "ຍອດລວມການຂາຍ",
    // TODO_LO: Customer pays via QR or bank transfer to the shop account.
    "qrPay.step1": "ລູກຄ້າຈ່າຍດ້ວຍ QR ຫຼື ໂອນເຂົ້າບັນຊີຮ້ານ.",
    // TODO_LO: Customer shows the bank slip on their phone.
    "qrPay.step2": "ລູກຄ້າສະແດງໃບສະຫຼິບທີ່ໂທລະສັບ.",
    // TODO_LO: Scan the OneProof QR on the slip — the transaction ID will fill in below.
    "qrPay.step3": "ສະແກນ QR OneProof ໃນໃບສະຫຼິບ — ເລກທຸລະກຳຈະຖືກຕື່ມລົງລຸ່ມ.",
    // TODO_LO: Transaction ID
    "qrPay.reference": "ເລກທຸລະກຳ",
    // TODO_LO: Scan the OneProof QR on the bank slip
    "qrPay.referencePlaceholder": "ສະແກນ QR OneProof ຈາກໃບສະຫຼິບທະນາຄານ",
    // TODO_LO: Tip: focus this field, then scan. The barcode scanner will fill it for you. You can also paste or type manually.
    "qrPay.referenceHint": "ເຄັດລັບ: ຄລິກໃສ່ຊ່ອງນີ້ກ່ອນ ແລ້ວສະແກນ. ເຄື່ອງສະແກນບາໂຄດຈະຕື່ມໃຫ້. ຫຼື ຈະວາງ ຫຼື ພິມເອງກໍໄດ້.",
    // TODO_LO: I verified the payment was received.
    "qrPay.acknowledge": "ຂ້ອຍກວດສອບວ່າໄດ້ຮັບເງິນແລ້ວ.",
    // TODO_LO: Confirm QR / Transfer sale
    "qrPay.confirm": "ຢືນຢັນການຂາຍ QR / ໂອນ",
    // ---------- Held bills ----------
    "heldBills.title": "ບິນທີ່ຄ້າງໄວ້",
    "heldBills.empty": "ບໍ່ມີບິນທີ່ຄ້າງໄວ້",
    "heldBills.resume": "ສືບຕໍ່",
    "heldBills.discard": "ຖິ້ມ",
    "heldBills.openedAt": "ເປີດເມື່ອ",
    "heldBills.itemCount": "ຈຳນວນລາຍການ",
    "heldBills.subtitleEmpty": "ບໍ່ມີບິນທີ່ຄ້າງໄວ້",
    "heldBills.subtitleCount": "ບິນທີ່ຄ້າງໄວ້",
    "heldBills.cartEmptyHint": "ບໍ່ມີບິນທີ່ຄ້າງໄວ້. ກົດ \"ຄ້າງໄວ້\" ໃນໜ້າຂາຍເພື່ອພັກບິນທີ່ນີ້.",
    // TODO_LO: Walk-in customer's held bill
    "heldBills.walkInTitle": "ບິນຄ້າງຂອງລູກຄ້າທົ່ວໄປ",
    // TODO_LO: {name}'s held bill
    "heldBills.namedTitle": "ບິນຄ້າງຂອງ {name}",
    // ---------- Login ----------
    "login.title": "ເຂົ້າສູ່ລະບົບ",
    "login.email": "ຊື່ຜູ້ໃຊ້",
    "login.username": "ຊື່ຜູ້ໃຊ້",
    "login.password": "ລະຫັດຜ່ານ",
    "login.signIn": "ເຂົ້າສູ່ລະບົບ",
    // TODO_LO: Invalid username or password.
    "login.invalid": "ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ.",
    // ---------- Forced password change ----------
    // TODO_LO: best-effort Lao — verify with a native speaker.
    "changePassword.title": "ປ່ຽນລະຫັດຜ່ານ",
    // TODO_LO: You must change your password before continuing.
    "changePassword.subtitle": "ທ່ານຕ້ອງປ່ຽນລະຫັດຜ່ານກ່ອນຈຶ່ງຈະດຳເນີນຕໍ່ໄດ້.",
    // TODO_LO: Current password
    "changePassword.currentPassword": "ລະຫັດຜ່ານປະຈຸບັນ",
    // TODO_LO: New password
    "changePassword.newPassword": "ລະຫັດຜ່ານໃໝ່",
    // TODO_LO: Confirm new password
    "changePassword.confirmPassword": "ຢືນຢັນລະຫັດຜ່ານໃໝ່",
    // TODO_LO: Passwords do not match
    "changePassword.errorMismatch": "ລະຫັດຜ່ານບໍ່ຕົງກັນ",
    // TODO_LO: Password must be at least 8 characters
    "changePassword.errorMinLength": "ລະຫັດຜ່ານຕ້ອງມີຢ່າງໜ້ອຍ 8 ຕົວອັກສອນ",
    // TODO_LO: Change password
    "changePassword.submit": "ປ່ຽນລະຫັດຜ່ານ",
    // ---------- Recent sales ----------
    "recentSales.title": "ການຂາຍຫຼ້າສຸດ",
    "recentSales.empty": "ບໍ່ມີການຂາຍ",
    "recentSales.reprint": "ພິມຄືນ",
    "recentSales.void": "ຍົກເລີກບິນ",
    "recentSales.colTime": "ເວລາ",
    "recentSales.colItems": "ລາຍການ",
    "recentSales.colTender": "ການຊຳລະ",
    "recentSales.colTotal": "ລວມ",
    "recentSales.colCustomer": "ລູກຄ້າ",
    "recentSales.colReceipt": "ເລກບິນ",
    "recentSales.colCashier": "ພະນັກງານ",
    "recentSales.rangeToday": "ມື້ນີ້",
    "recentSales.range7d": "7 ມື້ຜ່ານມາ",
    "recentSales.range30d": "30 ມື້ຜ່ານມາ",
    "recentSales.subtitle": "ການຂາຍໃນຊ່ວງເວລາ",
    "recentSales.subtitleOne": "ການຂາຍໃນຊ່ວງເວລາ",
    "recentSales.noneInRange": "ບໍ່ມີການຂາຍໃນຊ່ວງເວລານີ້.",
    "recentSales.detailHeading": "ລາຍລະອຽດການຂາຍ",
    "recentSales.walkInShort": "ລູກຄ້າທົ່ວໄປ",
    // TODO_LO: Completed
    "recentSales.statusCompleted": "ສຳເລັດແລ້ວ",
    // TODO_LO: Voided
    "recentSales.statusVoided": "ຍົກເລີກແລ້ວ",
    // TODO_LO: Refunded
    "recentSales.statusRefunded": "ຄືນເງິນແລ້ວ",
    // TODO_LO: Conflict pending
    "recentSales.statusConflictPending": "ລໍຖ້າແກ້ໄຂຂໍ້ຂັດແຍ້ງ",
    // TODO_LO: This sale is already voided.
    "recentSales.voidBlockedVoided": "ການຂາຍນີ້ຖືກຍົກເລີກໄປແລ້ວ.",
    // TODO_LO: Refunded sales cannot be voided.
    "recentSales.voidBlockedRefunded": "ການຂາຍທີ່ຄືນເງິນແລ້ວບໍ່ສາມາດຍົກເລີກໄດ້.",
    // TODO_LO: Resolve the open conflict for this sale before voiding it.
    "recentSales.voidBlockedConflict": "ກະລຸນາແກ້ໄຂຂໍ້ຂັດແຍ້ງຂອງການຂາຍນີ້ກ່ອນຈຶ່ງຍົກເລີກ.",
    // ---------- Receipt ----------
    // TODO_LO: Sale complete
    "receipt.saleComplete": "ການຂາຍສຳເລັດ",
    // TODO_LO: Receipt was not sent to the printer
    "receipt.printNotSent": "ໃບບິນບໍ່ໄດ້ຖືກສົ່ງໄປເຄື່ອງພິມ",
    // ---------- Quotations ----------
    "quotations.title": "ໃບສະເໜີລາຄາ",
    "quotations.empty": "ບໍ່ມີໃບສະເໜີລາຄາ",
    "quotations.create": "ສ້າງໃບສະເໜີລາຄາ",
    "quotations.colNumber": "ເລກທີ",
    "quotations.colCustomer": "ລູກຄ້າ",
    "quotations.colTotal": "ລວມ",
    "quotations.colStatus": "ສະຖານະ",
    "quotations.colCreatedAt": "ສ້າງເມື່ອ",
    "quotations.print": "ພິມ",
    "quotations.duplicate": "ສຳເນົາ",
    "quotations.markPaid": "ໝາຍວ່າຈ່າຍແລ້ວ",
    "quotations.markUnpaid": "ໝາຍວ່າຍັງບໍ່ຈ່າຍ",
    "quotations.filterUnpaid": "ຍັງບໍ່ຈ່າຍ",
    "quotations.filterPaid": "ຈ່າຍແລ້ວ",
    "quotations.filterAll": "ທັງໝົດ",
    "quotations.delete": "ລຶບ",
    "quotations.edit": "ແກ້ໄຂ",
    "quotations.save": "ບັນທຶກ",
    "quotations.cancel": "ຍົກເລີກ",
    "quotations.addLine": "ເພີ່ມລາຍການ",
    "quotations.removeLine": "ລຶບ",
    "quotations.modalTitle": "ໃບສະເໜີລາຄາໃໝ່",
    "quotations.customerLabel": "ລູກຄ້າ",
    "quotations.validUntil": "ໝົດອາຍຸວັນທີ",
    "quotations.noteLabel": "ບັນທຶກ (ບໍ່ບັງຄັບ)",
    "quotations.lineUnit": "ລາຄາ",
    "quotations.lineQty": "ຈໍານວນ",
    "quotations.lineTotal": "ລວມ",
    "quotations.lastPrinted": "ພິມຄັ້ງສຸດທ້າຍ",
    "quotations.searchProduct": "ຄົ້ນຫາສິນຄ້າ…",
    "quotations.searchCustomer": "ຄົ້ນຫາລູກຄ້າ…",
    "quotations.walkIn": "ລູກຄ້າທົ່ວໄປ",
    "quotations.statusPaid": "ຈ່າຍແລ້ວ",
    "quotations.statusUnpaid": "ຍັງບໍ່ຈ່າຍ",
    "quotations.subtitleUnpaid": "ໃບສະເໜີລາຄາທີ່ຍັງບໍ່ຈ່າຍ",
    "quotations.subtitlePaid": "ໃບສະເໜີລາຄາທີ່ຈ່າຍແລ້ວ",
    "quotations.subtitleAll": "ໃບສະເໜີລາຄາທັງໝົດ",
    "quotations.validUntilShort": "ໝົດອາຍຸວັນທີ",
    "quotations.lineCount": "ລາຍການ",
    "quotations.selectPrompt": "ເລືອກໃບສະເໜີລາຄາທາງຊ້າຍເພື່ອເບິ່ງຕົວຢ່າງ ແລະ ດຳເນີນການ.",
    "quotations.colProduct": "ສິນຄ້າ",
    "quotations.linked": "ເຊື່ອມຕໍ່ແລ້ວ",
    "quotations.notePrefix": "ບັນທຶກ",
    "quotations.closeEditor": "ປິດຕົວແກ້ໄຂ",
    // ---------- Shift ----------
    "shift.title": "ຮອບວຽກ",
    "shift.openShift": "ເປີດຮອບວຽກ",
    "shift.closeShift": "ປິດຮອບວຽກ",
    "shift.openingFloat": "ເງິນສົດເລີ່ມຕົ້ນ",
    "shift.countedAmount": "ຈຳນວນທີ່ນັບໄດ້",
    "shift.payIn": "ນຳເງິນເຂົ້າ",
    "shift.payOut": "ນຳເງິນອອກ",
    "shift.note": "ບັນທຶກ",
    "shift.expectedCash": "ເງິນສົດທີ່ຄາດໄວ້",
    "shift.diff": "ຜົນຕ່າງ",
    "shift.movements": "ການເຄື່ອນໄຫວ",
    "shift.startedAt": "ເລີ່ມເມື່ອ",
    "shift.openedAtPrefix": "ເປີດເມື່ອ",
    "shift.cashierPrefix": "ພະນັກງານ",
    "shift.kpiCashSales": "ຍອດຂາຍສົດ",
    "shift.kpiExpenses": "ລາຍຈ່າຍ",
    "shift.kpiExpected": "ຄາດໄວ້",
    "shift.tenderSplit": "ການແບ່ງການຊຳລະ",
    "shift.cashTimeline": "ຕາຕະລາງເງິນສົດ",
    "shift.denominationCount": "ການນັບແບງເງິນ",
    "shift.countedCashDirect": "ນັບເງິນສົດ (ປ້ອນໂດຍກົງ)",
    "shift.differenceLabel": "ຜົນຕ່າງ",
    "shift.varianceWithin1k": "ຢູ່ໃນ ±1,000 ₭ — ສາມາດປິດໄດ້.",
    "shift.varianceWithin50k": "ຢູ່ໃນ ±50,000 ₭ — ຮັບໄດ້, ຕ້ອງເຊັນຍອມຮັບ.",
    "shift.varianceOver50k": "ເກີນ ±50,000 ₭ — ຕ້ອງໄດ້ຮັບການອະນຸມັດຈາກຜູ້ຈັດການ.",
    "shift.callManager": "ເອີ້ນຜູ້ຈັດການ",
    "shift.closeAndPrint": "ປິດຮອບວຽກ ແລະ ພິມສະຫຼຸບ",
    "shift.expectedSep": "ຄາດໄວ້",
    "shift.countedSep": "ນັບໄດ້",
    "shift.totalCounted": "ລວມທີ່ນັບໄດ້",
    "shift.colMethod": "ວິທີການ",
    "shift.colCount": "ຈຳນວນ",
    "shift.colTotal": "ລວມ",
    "shift.noSalesYet": "ຍັງບໍ່ມີການຂາຍ.",
    "shift.entrySale": "ການຂາຍ",
    "shift.entryExpense": "ລາຍຈ່າຍ",
    "shift.entryMovementIn": "ນຳເງິນເຂົ້າ",
    "shift.entryMovementOut": "ນຳເງິນອອກ",
    // ---------- Till settings ----------
    "tillSettings.title": "ການຕັ້ງຄ່າໜ້າຂາຍ",
    "tillSettings.version": "ເວີຊັ່ນ",
    // TODO_LO: review wording with native speaker
    "tillSettings.pwaHardwareNote": "ທ່ານກຳລັງໃຊ້ແອັບເວັບ. ເຄື່ອງພິມໃບບິນ, ລິ້ນຊັກເງິນ ແລະ ເຄື່ອງພິມປ້າຍລາຄາ ຢູ່ໃນແອັບເດັສທັອບ — ຊ່ອງເຫຼົ່ານີ້ສະແດງເພື່ອອ້າງອີງເທົ່ານັ້ນ. ເປີດແອັບເດັສທັອບເພື່ອປ່ຽນຮາດແວ.",
    "tillSettings.printer": "ເຄື່ອງພິມ",
    "tillSettings.drawer": "ລິ້ນຊັກເງິນ",
    "tillSettings.connection": "ການເຊື່ອມຕໍ່",
    "tillSettings.language": "ພາສາ",
    "tillSettings.catalogSync": "ຊິ້ງຂໍ້ມູນສິນຄ້າ",
    "tillSettings.receiptLayout": "ຮູບແບບໃບບິນ",
    "tillSettings.dangerZone": "ເຂດອັນຕະລາຍ",
    "tillSettings.testPrint": "ທົດສອບການພິມ",
    "tillSettings.testKick": "ທົດສອບເປີດລິ້ນຊັກ",
    "tillSettings.resyncNow": "ຊິ້ງໃໝ່ດຽວນີ້",
    "tillSettings.lastSync": "ຊິ້ງຄັ້ງລ່າສຸດ",
    "tillSettings.testOk": "ທົດສອບຜ່ານ",
    "tillSettings.testError": "ທົດສອບລົ້ມເຫຼວ",
    "tillSettings.testing": "ກຳລັງທົດສອບ",
    "tillSettings.notTested": "ຍັງບໍ່ໄດ້ທົດສອບ",
    // TODO_LO: Windows printer (USB / installed)
    "tillSettings.transportWindows": "ເຄື່ອງພິມ Windows (USB / ຕິດຕັ້ງແລ້ວ)",
    "tillSettings.transportNetwork": "ເຄືອຂ່າຍ",
    "tillSettings.transportFile": "ໄຟລ໌",
    "tillSettings.transportNone": "ບໍ່ມີ",
    // TODO_LO: Windows printer
    "tillSettings.windowsPrinter": "ເຄື່ອງພິມ Windows",
    // TODO_LO: — Choose a printer —
    "tillSettings.choosePrinter": "— ເລືອກເຄື່ອງພິມ —",
    // TODO_LO: (default)
    "tillSettings.printerDefaultTag": "(ຄ່າເລີ່ມຕົ້ນ)",
    // TODO_LO: No installed printers found...
    "tillSettings.noPrintersFound": "ບໍ່ພົບເຄື່ອງພິມທີ່ຕິດຕັ້ງ. ກະລຸນາຕິດຕັ້ງເຄື່ອງພິມໃນ Windows ກ່ອນ ແລ້ວເປີດການຕັ້ງຄ່າຄືນໃໝ່.",
    // TODO_LO: Label printer
    "tillSettings.labelPrinter": "ເຄື່ອງພິມປ້າຍ",
    // TODO_LO: Test label
    "tillSettings.testLabel": "ທົດສອບປ້າຍ",
    // TODO_LO: Label printer hint
    "tillSettings.labelPrinterHint": "ພິມປ້າຍລາຄາ/ບາໂຄດສິນຄ້າ. ໃຊ້ເຄື່ອງພິມ Windows ຫຼື ທີ່ຢູ່ເຄືອຂ່າຍ ຄືກັນກັບເຄື່ອງພິມໃບບິນ.",
    "tillSettings.enabledOption": "ເປີດໃຊ້",
    "tillSettings.disabledOption": "ປິດໃຊ້",
    "tillSettings.host": "ໂຮສ",
    "tillSettings.port": "ພອດ",
    "tillSettings.paperWidth": "ຄວາມກວ້າງເຈ້ຍ",
    "tillSettings.codepage": "ໂຄດເພຈ",
    "tillSettings.drawerPin": "ຂາ PIN ລິ້ນຊັກ",
    "tillSettings.drawerPin0": "ຂາ PIN 0",
    "tillSettings.drawerPin1": "ຂາ PIN 1",
    "tillSettings.kickOnCash": "ເປີດລິ້ນຊັກເມື່ອຮັບເງິນສົດ",
    "tillSettings.kickOnCashYes": "ແມ່ນ",
    "tillSettings.kickOnCashNo": "ບໍ່",
    "tillSettings.apiBaseUrl": "API Base URL",
    "tillSettings.syncInterval": "ໄລຍະເວລາຊິ້ງ",
    "tillSettings.interfaceLanguage": "ພາສາ",
    "tillSettings.languageHint": "ປ່ຽນພາສາຂອງໜ້າຈໍ",
    "tillSettings.never": "ບໍ່ເຄີຍ",
    "tillSettings.cacheHint": "ລ້າງຂໍ້ມູນທີ່ເກັບໄວ້ໃນເຄື່ອງ",
    "tillSettings.receiptHeader": "ຫົວໃບບິນ",
    "tillSettings.receiptFooter": "ທ້າຍໃບບິນ",
    "tillSettings.dangerHint": "ການກະທຳເຫຼົ່ານີ້ບໍ່ສາມາດກູ້ຄືນໄດ້",
    "tillSettings.clearCache": "ລ້າງແຄຊ",
    "tillSettings.signOut": "ອອກຈາກລະບົບ",
    "tillSettings.languageEnglish": "English",
    "tillSettings.languageLao": "ລາວ",
    // ---------- Manage / Dashboard ----------
    // TODO_LO: full sweep
    "dashboard.title": "ພາບລວມ",
    "dashboard.kpiSalesToday": "ຍອດຂາຍມື້ນີ້",
    "dashboard.kpiOrdersToday": "ຄຳສັ່ງຊື້ມື້ນີ້",
    "dashboard.kpiAvgOrder": "ຄ່າສະເລ່ຍຕໍ່ບິນ",
    "dashboard.kpiOpenDrawers": "ລິ້ນຊັກທີ່ເປີດຢູ່",
    "dashboard.recentSales": "ການຂາຍຫຼ້າສຸດ",
    "dashboard.lowStock": "ສິນຄ້າເຫຼືອໜ້ອຍ",
    "dashboard.alerts": "ການແຈ້ງເຕືອນ",
    "dashboard.topProducts": "ສິນຄ້າຂາຍດີ",
    // ---------- Sales History ----------
    // TODO_LO: full sweep
    "salesHistory.title": "ປະຫວັດການຂາຍ",
    "salesHistory.filterStore": "ຮ້ານ",
    "salesHistory.filterCashier": "ພະນັກງານ",
    "salesHistory.filterTender": "ການຊຳລະ",
    "salesHistory.filterStatus": "ສະຖານະ",
    "salesHistory.filterDateFrom": "ຈາກວັນທີ",
    "salesHistory.filterDateTo": "ຮອດວັນທີ",
    // TODO_LO: Search receipt # / customer / reference
    "salesHistory.filterSearch": "ຄົ້ນຫາ ເລກບິນ / ລູກຄ້າ / ເລກທຸລະກຳ",
    "salesHistory.colTime": "ເວລາ",
    "salesHistory.colReceipt": "ເລກບິນ",
    "salesHistory.colCashier": "ພະນັກງານ",
    "salesHistory.colCustomer": "ລູກຄ້າ",
    "salesHistory.colItems": "ລາຍການ",
    "salesHistory.colTender": "ການຊຳລະ",
    "salesHistory.colTotal": "ລວມ",
    "salesHistory.colStatus": "ສະຖານະ",
    "salesHistory.empty": "ບໍ່ມີການຂາຍ",
    "salesHistory.export": "ສົ່ງອອກ",
    // ---------- Customers ----------
    "customers.title": "ລູກຄ້າ",
    "customers.create": "ສ້າງລູກຄ້າໃໝ່",
    "customers.edit": "ແກ້ໄຂລູກຄ້າ",
    "customers.searchPlaceholder": "ຄົ້ນຫາລູກຄ້າ…",
    "customers.colName": "ຊື່",
    "customers.colPhone": "ເບີໂທ",
    "customers.colTier": "ລະດັບ",
    "customers.colPoints": "ຄະແນນ",
    "customers.colBalance": "ຍອດຄົງເຫຼືອ",
    "customers.colStore": "ຮ້ານ",
    "customers.empty": "ບໍ່ມີລູກຄ້າ",
    // ---------- Products ----------
    "products.title": "ສິນຄ້າ",
    "products.create": "ສ້າງສິນຄ້າໃໝ່",
    "products.import": "ນໍາເຂົ້າ",
    "products.export": "ສົ່ງອອກ",
    "products.bulkPrice": "ປ່ຽນລາຄາຫຼາຍລາຍການ",
    "products.searchPlaceholder": "ຄົ້ນຫາສິນຄ້າ…",
    "products.filterCategory": "ໝວດໝູ່",
    "products.filterBrand": "ຍີ່ຫໍ້",
    "products.filterSupplier": "ຜູ້ສະໜອງ",
    "products.filterLowStock": "ສິນຄ້າເຫຼືອໜ້ອຍ",
    "products.filterStatus": "ສະຖານະ",
    "products.colName": "ຊື່",
    "products.colSku": "SKU",
    "products.colBarcode": "ບາໂຄດ",
    "products.colCategory": "ໝວດໝູ່",
    "products.colBrand": "ຍີ່ຫໍ້",
    "products.colPrice": "ລາຄາ",
    "products.colCost": "ຕົ້ນທຶນ",
    "products.colStock": "ສາງ",
    "products.colStatus": "ສະຖານະ",
    "products.empty": "ບໍ່ມີສິນຄ້າ",
    // ---------- Add product ----------
    "addProduct.title": "ເພີ່ມສິນຄ້າ",
    "addProduct.editTitle": "ແກ້ໄຂສິນຄ້າ",
    "addProduct.basics": "ຂໍ້ມູນພື້ນຖານ",
    "addProduct.pricing": "ລາຄາ",
    "addProduct.units": "ຫົວໜ່ວຍ",
    "addProduct.stock": "ສາງ",
    "addProduct.tags": "ແທັກ",
    "addProduct.save": "ບັນທຶກ",
    "addProduct.cancel": "ຍົກເລີກ",
    "addProduct.namePlaceholder": "ຊື່ສິນຄ້າ",
    "addProduct.skuPlaceholder": "SKU",
    "addProduct.barcodePlaceholder": "ບາໂຄດ",
    "addProduct.image": "ຮູບ", // TODO_LO: confirm "Photo"
    "addProduct.imageChoose": "ເລືອກຮູບ", // TODO_LO: confirm "Choose photo"
    "addProduct.imageReplace": "ປ່ຽນຮູບ", // TODO_LO: confirm "Replace photo"
    "addProduct.imageRemove": "ລຶບ", // TODO_LO: confirm "Remove"
    "addProduct.imageProcessing": "ກຳລັງປະມວນຜົນ…", // TODO_LO: confirm
    "addProduct.imageHint": "JPG/PNG. ຍໍ້ອັດຕະໂນມັດໃຫ້ພໍດີໝາຍ.", // TODO_LO: confirm "Auto-resized to fit the tile"
    "addProduct.imageReadError": "ບໍ່ສາມາດອ່ານຮູບໄດ້. ກະລຸນາລອງ JPG ຫຼື PNG.", // TODO_LO: confirm
    // Tabs
    "addProduct.tabGeneral": "ທົ່ວໄປ",
    "addProduct.tabUnits": "ຫົວໜ່ວຍ ແລະ ລາຄາ",
    "addProduct.tabInventory": "ສິນຄ້າຄົງຄັງ",
    "addProduct.tabLabels": "ປ້າຍ",
    // General tab
    "addProduct.name": "ຊື່",
    "addProduct.nameExample": "ເຊັ່ນ: ໂຄຄາໂຄລາ 500ml",
    "addProduct.id": "ລະຫັດ",
    "addProduct.barcode": "ບາໂຄດ",
    "addProduct.category": "ໝວດໝູ່",
    "addProduct.brand": "ຍີ່ຫໍ້",
    "addProduct.supplier": "ຜູ້ສະໜອງ",
    "addProduct.select": "ເລືອກ…",
    "addProduct.saveChanges": "ບັນທຶກການປ່ຽນແປງ",
    "addProduct.saving": "ກຳລັງບັນທຶກ…",
    // Units & Pricing tab
    "addProduct.costPerBase": "ຕົ້ນທຶນ (ຕໍ່ຫົວໜ່ວຍຫຼັກ)",
    "addProduct.sellPricePerBase": "ລາຄາຂາຍ (ຕໍ່ຫົວໜ່ວຍຫຼັກ)",
    "addProduct.margin": "ກຳໄລ:",
    "addProduct.sellableUnits": "ຫົວໜ່ວຍທີ່ຂາຍໄດ້",
    "addProduct.sellableUnitsHint": "ເລືອກຫົວໜ່ວຍຫຼັກ (ກິໂລ, ອັນ, ແລະ ອື່ນໆ) ແລ້ວເພີ່ມຫຸ້ມໃຫຍ່ (ກະສອບ 10 ກິໂລ, ກະສອບ 50 ກິໂລ). ອັດຕາສ່ວນແມ່ນ \"ມີຈັກຫົວໜ່ວຍຫຼັກໃນຫຸ້ມນີ້\".",
    "addProduct.addUnit": "ເພີ່ມຫົວໜ່ວຍ",
    "addProduct.unitName": "ຊື່ຫົວໜ່ວຍ",
    "addProduct.unitNameBasePlaceholder": "ກິໂລ / ອັນ / ກະສອບ",
    "addProduct.unitNamePackPlaceholder": "ກະສອບ 10 ກິໂລ",
    "addProduct.ratioToBase": "ອັດຕາສ່ວນຕໍ່ຫົວໜ່ວຍຫຼັກ",
    "addProduct.sellPrice": "ລາຄາຂາຍ",
    "addProduct.usesBase": "(ໃຊ້ຫົວໜ່ວຍຫຼັກ)",
    "addProduct.setBase": "ຕັ້ງເປັນຫຼັກ",
    "addProduct.base": "ຫຼັກ",
    "addProduct.makeBase": "ຕັ້ງອັນນີ້ເປັນຫົວໜ່ວຍຫຼັກ",
    "addProduct.removeUnit": "ລຶບຫົວໜ່ວຍ",
    "addProduct.unitsExample": "ຕົວຢ່າງ: ອາຫານສັດຂາຍເປັນກິໂລ → ຫົວໜ່ວຍຫຼັກ \"ກິໂລ\", ເພີ່ມ \"ກະສອບ 10 ກິໂລ\" ອັດຕາສ່ວນ 10 ລາຄາ 95,000 ₭, \"ກະສອບ 50 ກິໂລ\" ອັດຕາສ່ວນ 50 ລາຄາ 450,000 ₭.",
    // Inventory tab
    "addProduct.reorderPoint": "ຈຸດສັ່ງຊື້ໃໝ່",
    "addProduct.openingStock": "ສິນຄ້າຄົງຄັງເລີ່ມຕົ້ນ",
    "addProduct.stockEditDisabled": "ການແກ້ໄຂສິນຄ້າຄົງຄັງຢູ່ນີ້ຖືກປິດໄວ້ — ໃຫ້ໃຊ້ ຮັບສິນຄ້າ ຫຼື ນັບສິນຄ້າ ເພື່ອປ່ຽນຈຳນວນ ເພື່ອໃຫ້ບັນທຶກການກວດສອບເກັບເຫດຜົນໄວ້.",
    // Labels tab
    "addProduct.labelProductName": "ຊື່ສິນຄ້າ",
    "addProduct.labelBarcode": "ບາໂຄດ",
    "addProduct.labelPreview": "ຕົວຢ່າງ 40 × 30 ມມ",
    "addProduct.print1Label": "ພິມປ້າຍ 1 ໃບ",
    "addProduct.printLabelTillOnly": "ການພິມປ້າຍໃຊ້ໄດ້ສະເພາະເຄື່ອງ Till ເທົ່ານັ້ນ; ກະລຸນາເປີດໜ້ານີ້ຢູ່ເຄື່ອງຂາຍທີ່ມີເຄື່ອງພິມປ້າຍ.",
    "addProduct.printLabelAria": "ບັນທຶກສິນຄ້າ ແລະ ພິມປ້າຍ 1 ໃບ",
    // ---------- Add expense modal ----------
    "addExpense.title": "ເພີ່ມລາຍຈ່າຍ",
    "addExpense.save": "ບັນທຶກລາຍຈ່າຍ",
    "addExpense.saving": "ກຳລັງບັນທຶກ…",
    "addExpense.cancel": "ຍົກເລີກ",
    "addExpense.category": "ໝວດໝູ່",
    "addExpense.date": "ວັນທີ",
    "addExpense.amount": "ຈຳນວນເງິນ (₭)",
    "addExpense.amountPlaceholder": "0",
    "addExpense.payMethod": "ວິທີຈ່າຍ",
    "addExpense.description": "ລາຍລະອຽດ (ບໍ່ບັງຄັບ)",
    "addExpense.descriptionPlaceholder": "ເຊັ່ນ: ເຄື່ອງໃຊ້ຫ້ອງການ — ຕະຫຼາດວັນອັງຄານ",
    "addExpense.newCategoryPlaceholder": "ເຊັ່ນ: ຄ່ານ້ຳຄ່າໄຟ",
    "addExpense.saveCategory": "ບັນທຶກ",
    "addExpense.new": "ໃໝ່",
    "addExpense.payCash": "ເງິນສົດ (ຈາກລິ້ນຊັກ)",
    "addExpense.payBank": "ໂອນທະນາຄານ",
    "addExpense.payOther": "ອື່ນໆ",
    "addExpense.noCategoriesAdmin": "ຍັງບໍ່ໄດ້ຕັ້ງໝວດໝູ່ລາຍຈ່າຍ. ກະລຸນາໃຫ້ຜູ້ດູແລລະບົບສ້າງຢ່າງໜ້ອຍໜຶ່ງໝວດກ່ອນບັນທຶກລາຍຈ່າຍ.",
    "addExpense.noCategoriesHint": "ຍັງບໍ່ມີໝວດໝູ່ — ພິມຊື່ຂ້າງເທິງ ແລ້ວກົດ ບັນທຶກ ເພື່ອສ້າງໝວດທຳອິດ (ເຊັ່ນ: ຄ່າເຊົ່າ, ຄ່ານ້ຳຄ່າໄຟ, ຄ່າແຮງງານ).",
    "addExpense.deleteConfirm": "ລຶບ \"{name}\" ອອກຈາກລາຍຈ່າຍໃນອະນາຄົດບໍ? ລາຍການລາຍຈ່າຍທີ່ມີຢູ່ແລ້ວຈະຍັງເກັບປະຫວັດໄວ້.",
    // aria-labels
    "addExpense.newCategoryNameAria": "ຊື່ໝວດໝູ່ໃໝ່",
    "addExpense.saveNewCategoryAria": "ບັນທຶກໝວດໝູ່ໃໝ່",
    "addExpense.cancelNewCategoryAria": "ຍົກເລີກໝວດໝູ່ໃໝ່",
    "addExpense.expenseCategoryAria": "ໝວດໝູ່ລາຍຈ່າຍ",
    "addExpense.addNewCategoryAria": "ເພີ່ມໝວດໝູ່ໃໝ່",
    "addExpense.deleteCategoryAria": "ລຶບໝວດໝູ່ {name}",
    "addExpense.payDateAria": "ວັນທີຈ່າຍ",
    "addExpense.amountAria": "ຈຳນວນເງິນລາຍຈ່າຍ",
    "addExpense.descriptionAria": "ລາຍລະອຽດລາຍຈ່າຍ",
    // ---------- Bulk price ----------
    "bulkPrice.title": "ປ່ຽນລາຄາຫຼາຍລາຍການ",
    "bulkPrice.percent": "ເປີເຊັນ",
    "bulkPrice.up": "ຂຶ້ນ",
    "bulkPrice.down": "ລົງ",
    "bulkPrice.roundTo": "ປັດເສດເປັນ",
    "bulkPrice.affected": "ສິນຄ້າທີ່ໄດ້ຮັບຜົນກະທົບ",
    "bulkPrice.apply": "ນຳໃຊ້",
    // ---------- Import products ----------
    "importProducts.title": "ນຳເຂົ້າສິນຄ້າ",
    "importProducts.uploadCta": "ອັບໂຫລດໄຟລ໌",
    "importProducts.dropHint": "ລາກໄຟລ໌ມາວາງທີ່ນີ້ ຫຼື ກົດເພື່ອເລືອກ",
    "importProducts.preview": "ຕົວຢ່າງ",
    "importProducts.column": "ຄໍລຳ",
    "importProducts.mapTo": "ແມັບໄປຫາ",
    "importProducts.rows": "ແຖວ",
    "importProducts.errors": "ຂໍ້ຜິດພາດ",
    "importProducts.commit": "ນໍາເຂົ້າ",
    "importProducts.cancel": "ຍົກເລີກ",
    "importProducts.success": "ນຳເຂົ້າສຳເລັດ",
    "importProducts.failed": "ນຳເຂົ້າລົ້ມເຫຼວ",
    // ---------- Categories & Brands ----------
    "categoriesBrands.title": "ໝວດໝູ່ ແລະ ຍີ່ຫໍ້",
    "categoriesBrands.categories": "ໝວດໝູ່",
    "categoriesBrands.brands": "ຍີ່ຫໍ້",
    "categoriesBrands.addCategory": "ເພີ່ມໝວດໝູ່",
    "categoriesBrands.addBrand": "ເພີ່ມຍີ່ຫໍ້",
    "categoriesBrands.empty": "ວ່າງເປົ່າ",
    // ---------- Sale Reviews (internal key: "conflicts") ----------
    "conflicts.title": "ກວດການຂາຍ",
    "conflicts.empty": "ບໍ່ມີການຂາຍທີ່ຕ້ອງກວດ",
    "conflicts.colKind": "ປະເພດ",
    "conflicts.colEntity": "ຂໍ້ມູນ",
    "conflicts.colLocal": "ໃນເຄື່ອງ",
    "conflicts.colServer": "ເຊີບເວີ",
    "conflicts.colResolvedBy": "ແກ້ໄຂໂດຍ",
    "conflicts.acceptLocal": "ຮັບເອົາໃນເຄື່ອງ",
    "conflicts.acceptServer": "ຮັບເອົາເຊີບເວີ",
    // ---------- Expenses ----------
    "expenses.title": "ລາຍຈ່າຍ",
    "expenses.create": "ສ້າງລາຍຈ່າຍ",
    "expenses.colDate": "ວັນທີ",
    "expenses.colCategory": "ໝວດໝູ່",
    "expenses.colAmount": "ຈຳນວນເງິນ",
    "expenses.colPaidFrom": "ຈ່າຍຈາກ",
    "expenses.colDescription": "ລາຍລະອຽດ",
    "expenses.empty": "ບໍ່ມີລາຍຈ່າຍ",
    // TODO_LO: Search ID, date, category, description, amount, or recorder…
    "expenses.searchPlaceholder": "ຄົ້ນຫາ ລະຫັດ, ວັນທີ, ໝວດໝູ່, ລາຍລະອຽດ, ຈຳນວນເງິນ, ຫຼື ຜູ້ບັນທຶກ…",
    // ---------- Receive Goods ----------
    "receiveGoods.title": "ຮັບສິນຄ້າ",
    "receiveGoods.create": "ສ້າງໃບຮັບສິນຄ້າ",
    "receiveGoods.supplier": "ຜູ້ສະໜອງ",
    "receiveGoods.invoice": "ເລກໃບແຈ້ງໜີ້",
    "receiveGoods.received": "ວັນທີຮັບ",
    "receiveGoods.colSku": "SKU",
    "receiveGoods.colName": "ຊື່",
    "receiveGoods.colQty": "ຈຳນວນ",
    "receiveGoods.colCost": "ຕົ້ນທຶນ",
    "receiveGoods.empty": "ບໍ່ມີໃບຮັບສິນຄ້າ",
    // TODO_LO: Manual row
    "receiveGoods.manualRow": "",
    // TODO_LO: VAT
    "receiveGoods.vat": "",
    // ---------- Product Lookup (shared picker) ----------
    // TODO_LO: Find product
    "productLookup.title": "",
    // TODO_LO: Search by name, SKU, or barcode…
    "productLookup.searchPlaceholder": "",
    // TODO_LO: No products match.
    "productLookup.noMatches": "",
    // TODO_LO: Start typing to search products.
    "productLookup.startTyping": "",
    // TODO_LO: Searching…
    "productLookup.searching": "",
    // ---------- Stock by Store ----------
    "stockByStore.title": "ສາງຕາມຮ້ານ",
    "stockByStore.colSku": "SKU",
    "stockByStore.colProduct": "ສິນຄ້າ",
    "stockByStore.colTotal": "ລວມ",
    "stockByStore.empty": "ບໍ່ມີຂໍ້ມູນສາງ",
    // ---------- Stock Count ----------
    "stockCount.title": "ກວດນັບສາງ",
    "stockCount.create": "ສ້າງການກວດນັບ",
    "stockCount.colSku": "SKU",
    "stockCount.colProduct": "ສິນຄ້າ",
    "stockCount.colExpected": "ຄາດໄວ້",
    "stockCount.colCounted": "ນັບໄດ້",
    "stockCount.colVariance": "ຜົນຕ່າງ",
    "stockCount.empty": "ບໍ່ມີການກວດນັບ",
    "stockCount.commit": "ບັນທຶກການກວດນັບ",
    // TODO_LO: Start new stock count?
    "stockCount.confirmTitle": "",
    // TODO_LO: Start count
    "stockCount.confirmStart": "",
    // ---------- Stock Movements ----------
    "stockMovements.title": "ການເຄື່ອນໄຫວສາງ",
    "stockMovements.colDate": "ວັນທີ",
    "stockMovements.colProduct": "ສິນຄ້າ",
    "stockMovements.colKind": "ປະເພດ",
    "stockMovements.colQty": "ຈຳນວນ",
    "stockMovements.colNote": "ບັນທຶກ",
    "stockMovements.empty": "ບໍ່ມີການເຄື່ອນໄຫວ",
    // ---------- Suppliers ----------
    "suppliers.title": "ຜູ້ສະໜອງ",
    "suppliers.create": "ສ້າງຜູ້ສະໜອງ",
    "suppliers.searchPlaceholder": "ຄົ້ນຫາຜູ້ສະໜອງ…",
    "suppliers.colName": "ຊື່",
    "suppliers.colPhone": "ເບີໂທ",
    "suppliers.colEmail": "ອີເມວ",
    "suppliers.colNote": "ບັນທຶກ",
    "suppliers.empty": "ບໍ່ມີຜູ້ສະໜອງ",
    // ---------- Transfers ----------
    "transfers.title": "ການໂອນສິນຄ້າ",
    "transfers.create": "ສ້າງການໂອນ",
    "transfers.fromStore": "ຈາກຮ້ານ",
    "transfers.toStore": "ໄປຮ້ານ",
    "transfers.colCreated": "ສ້າງເມື່ອ",
    "transfers.colFrom": "ຈາກ",
    "transfers.colTo": "ໄປ",
    "transfers.colItems": "ລາຍການ",
    "transfers.colStatus": "ສະຖານະ",
    "transfers.empty": "ບໍ່ມີການໂອນ",
    // ---------- Promotions ----------
    "promotions.title": "ໂປຣໂມຊັ່ນ",
    "promotions.create": "ສ້າງໂປຣໂມຊັ່ນ",
    "promotions.colName": "ຊື່",
    "promotions.colKind": "ປະເພດ",
    "promotions.colStart": "ເລີ່ມ",
    "promotions.colEnd": "ສິ້ນສຸດ",
    "promotions.colStatus": "ສະຖານະ",
    "promotions.empty": "ບໍ່ມີໂປຣໂມຊັ່ນ",
    "promotions.builderTitle": "ສ້າງໂປຣໂມຊັ່ນ",
    "promotions.builderRule": "ເງື່ອນໄຂ",
    "promotions.builderReward": "ລາງວັນ",
    "promotions.builderSchedule": "ກຳນົດເວລາ",
    "promotions.builderConditions": "ຂໍ້ກຳນົດ",
    // ---------- Shifts & Drawers ----------
    "shiftsDrawers.title": "ຮອບວຽກ ແລະ ລິ້ນຊັກ",
    "shiftsDrawers.colStore": "ຮ້ານ",
    "shiftsDrawers.colCashier": "ພະນັກງານ",
    "shiftsDrawers.colOpenedAt": "ເປີດເມື່ອ",
    "shiftsDrawers.colClosedAt": "ປິດເມື່ອ",
    "shiftsDrawers.colExpected": "ຄາດໄວ້",
    "shiftsDrawers.colCounted": "ນັບໄດ້",
    "shiftsDrawers.colVariance": "ຜົນຕ່າງ",
    "shiftsDrawers.empty": "ບໍ່ມີຂໍ້ມູນ",
    // ---------- Staff ----------
    "staff.title": "ພະນັກງານ",
    "staff.create": "ເພີ່ມພະນັກງານ",
    "staff.searchPlaceholder": "ຄົ້ນຫາພະນັກງານ…",
    "staff.filterRole": "ບົດບາດ",
    "staff.filterStore": "ຮ້ານ",
    "staff.filterStatus": "ສະຖານະ",
    "staff.colName": "ຊື່",
    "staff.colEmail": "ອີເມວ",
    "staff.colRole": "ບົດບາດ",
    "staff.colStore": "ຮ້ານ",
    "staff.colLastActive": "ໃຊ້ງານຫຼ້າສຸດ",
    "staff.colStatus": "ສະຖານະ",
    "staff.empty": "ບໍ່ມີພະນັກງານ",
    "staff.tabProfile": "ຂໍ້ມູນສ່ວນຕົວ",
    "staff.tabRoleStore": "ບົດບາດ ແລະ ຮ້ານ",
    "staff.tabPermissions": "ສິດທິ",
    "staff.tabPassword": "ລະຫັດຜ່ານ",
    "staff.tabActivity": "ການເຄື່ອນໄຫວ",
    // ---------- Stores ----------
    "stores.title": "ຮ້ານ",
    "stores.create": "ສ້າງຮ້ານ",
    "stores.colName": "ຊື່",
    "stores.colCode": "ລະຫັດ",
    "stores.colAddress": "ທີ່ຢູ່",
    "stores.colPhone": "ເບີໂທ",
    "stores.colStatus": "ສະຖານະ",
    "stores.empty": "ບໍ່ມີຮ້ານ",
    // ---------- Reports ----------
    "reports.title": "ລາຍງານ",
    "reports.tabSales": "ການຂາຍ",
    "reports.tabProducts": "ສິນຄ້າ",
    "reports.tabCashiers": "ພະນັກງານ",
    "reports.tabCustomers": "ລູກຄ້າ",
    "reports.tabInventory": "ສາງ",
    "reports.tabExpenses": "ລາຍຈ່າຍ",
    "reports.tabPromotions": "ໂປຣໂມຊັ່ນ",
    "reports.exportXlsx": "ສົ່ງອອກ XLSX",
    "reports.exportAllXlsx": "ສົ່ງອອກທຸກລາຍງານ XLSX",
    "reports.dateRange": "ໄລຍະວັນທີ",
    "reports.empty": "ບໍ່ມີຂໍ້ມູນ",
    // ---------- Audit Log ----------
    "auditLog.title": "ບັນທຶກກວດສອບ",
    "auditLog.filterActor": "ຜູ້ກະທຳ",
    "auditLog.filterEntity": "ຂໍ້ມູນ",
    "auditLog.filterAction": "ການກະທຳ",
    "auditLog.filterDateFrom": "ຈາກວັນທີ",
    "auditLog.filterDateTo": "ຮອດວັນທີ",
    "auditLog.colTime": "ເວລາ",
    "auditLog.colActor": "ຜູ້ກະທຳ",
    "auditLog.colAction": "ການກະທຳ",
    "auditLog.colEntity": "ຂໍ້ມູນ",
    "auditLog.colDetails": "ລາຍລະອຽດ",
    "auditLog.empty": "ບໍ່ມີບັນທຶກ",
    "auditLog.export": "ສົ່ງອອກ",
    "auditLog.subtitleEvents": "ເຫດການ",
    "auditLog.subtitleImmutable": "ບໍ່ສາມາດແກ້ໄຂ",
    "auditLog.subtitleExportable": "ສົ່ງອອກໄດ້",
    "auditLog.allActors": "ຜູ້ກະທຳທັງໝົດ",
    "auditLog.allActions": "ການກະທຳທັງໝົດ",
    "auditLog.allTables": "ຕາຕະລາງທັງໝົດ",
    "auditLog.dateRangeSep": "ຮອດ",
    "auditLog.onPrefix": "ໃນ",
    "auditLog.diffField": "ຊ່ອງ",
    "auditLog.diffBefore": "ກ່ອນ",
    "auditLog.diffAfter": "ຫຼັງ",
    "auditLog.noFieldChanges": "ບໍ່ມີການປ່ຽນແປງລະດັບຊ່ອງ.",
    "auditLog.loadMore": "ໂຫລດເພີ່ມ",
    "auditLog.collapse": "ຫຼຸບ",
    "auditLog.expand": "ກາງອອກ",
    "auditAction.user_login": "ເຂົ້າສູ່ລະບົບ",
    "auditAction.user_login_password": "ເຂົ້າສູ່ລະບົບດ້ວຍລະຫັດຜ່ານ",
    "auditAction.user_create": "ສ້າງຜູ້ໃຊ້",
    "auditAction.user_updated": "ອັບເດດຜູ້ໃຊ້",
    "auditAction.user_deactivate": "ປິດການໃຊ້ຜູ້ໃຊ້",
    "auditAction.permission_change": "ປ່ຽນສິດທິ",
    "auditAction.price_change": "ປ່ຽນລາຄາ",
    "auditAction.void_sale": "ຍົກເລີກບິນ",
    "auditAction.apply_discount": "ນຳໃຊ້ສ່ວນຫຼຸດ",
    "auditAction.stock_adjust": "ປັບສາງ",
    "auditAction.receive_goods": "ຮັບສິນຄ້າ",
    "auditAction.transfer_send": "ສົ່ງການໂອນ",
    "auditAction.transfer_receive": "ຮັບການໂອນ",
    "auditAction.stocktake_submit": "ສົ່ງການກວດນັບ",
    "auditAction.stocktake_approve": "ອະນຸມັດການກວດນັບ",
    "auditAction.conflict_resolve": "ແກ້ໄຂການກວດການຂາຍ",
    "auditAction.drawer_opened": "ເປີດລິ້ນຊັກ",
    "auditAction.drawer_closed": "ປິດລິ້ນຊັກ",
    "auditAction.promotion_create": "ສ້າງໂປຣໂມຊັ່ນ",
    "auditAction.promotion_pause": "ຢຸດໂປຣໂມຊັ່ນ",
    "auditAction.product_create": "ສ້າງສິນຄ້າ",
    "auditAction.customer_created": "ສ້າງລູກຄ້າ",
    "auditAction.customer_credit": "ບັນທຶກເຄຣດິດ",
    "auditAction.supplier_payment": "ຈ່າຍຜູ້ສະໜອງ",
    "auditAction.expense_create": "ບັນທຶກລາຍຈ່າຍ",
    "auditAction.hold_order": "ຄ້າງບິນ",
    "auditAction.held_order_created": "ສ້າງບິນທີ່ຄ້າງໄວ້",
    "auditAction.settings_change": "ປ່ຽນການຕັ້ງຄ່າ",
    "auditAction.store_update": "ອັບເດດຮ້ານ",
    "auditAction.backup_run": "ສຳຮອງຂໍ້ມູນ",
    "auditAction.sale_created": "ການຂາຍສຳເລັດ",
    "auditAction.quotation_created": "ສ້າງໃບສະເໜີລາຄາ",
    "auditAction.quotation_deleted": "ລຶບໃບສະເໜີລາຄາ",
    "auditAction.quotation_duplicated": "ສຳເນົາໃບສະເໜີລາຄາ",
    "auditAction.quotation_printed": "ພິມໃບສະເໜີລາຄາ",
    "auditTable.customers": "ລູກຄ້າ",
    "auditTable.drawer_sessions": "ຮອບລິ້ນຊັກ",
    "auditTable.held_orders": "ບິນທີ່ຄ້າງໄວ້",
    "auditTable.quotations": "ໃບສະເໜີລາຄາ",
    "auditTable.sales": "ການຂາຍ",
    "auditTable.users": "ຜູ້ໃຊ້",
    "auditTable.products": "ສິນຄ້າ",
    "auditTable.suppliers": "ຜູ້ສະໜອງ",
    "auditTable.stores": "ຮ້ານ",
    "auditTable.expenses": "ລາຍຈ່າຍ",
    "auditTable.transfers": "ການໂອນ",
    "auditTable.promotions": "ໂປຣໂມຊັ່ນ",
    "auditTable.settings": "ການຕັ້ງຄ່າ",
    "auditTable.stocktakes": "ການກວດນັບສາງ",
    "auditTable.stock": "ສາງ",
    "auditTable.receivings": "ໃບຮັບສິນຄ້າ",
    "auditTable.backups": "ການສຳຮອງ",
    "auditTable.permissions": "ສິດທິ",
    "auditTable.shifts": "ຮອບວຽກ",
    // ---------- Global Settings ----------
    "globalSettings.title": "ການຕັ້ງຄ່າທົ່ວໄປ",
    "globalSettings.business": "ທຸລະກິດ",
    "globalSettings.tax": "ພາສີ",
    "globalSettings.receipt": "ໃບບິນ",
    "globalSettings.loyalty": "ຄະແນນສະສົມ",
    "globalSettings.security": "ຄວາມປອດໄພ",
    "globalSettings.backup": "ສຳຮອງຂໍ້ມູນ",
    "globalSettings.backupSuccess": "ສຳຮອງຂໍ້ມູນສຳເລັດ.",
    "globalSettings.backupFailed": "ສຳຮອງຂໍ້ມູນລົ້ມເຫຼວ.",
    "globalSettings.save": "ບັນທຶກ",
    "globalSettings.subtitle": "ການຕັ້ງຄ່າທົ່ວທັງອົງກອນ. ການປ່ຽນແປງຈະນຳໃຊ້ກັບທຸກຮ້ານ.",
    "globalSettings.notifications": "ການແຈ້ງເຕືອນ",
    "globalSettings.event": "ເຫດການ",
    "globalSettings.email": "ອີເມວ",
    "globalSettings.push": "ແຈ້ງເຕືອນ",
    "globalSettings.lastBackup": "ສຳຮອງຄັ້ງລ່າສຸດ:",
    "globalSettings.never": "ບໍ່ເຄີຍ",
    "globalSettings.schedule": "ກຳນົດການ",
    "globalSettings.scheduleDaily": "ປະຈຳວັນ",
    "globalSettings.scheduleWeekly": "ປະຈຳອາທິດ",
    "globalSettings.scheduleOff": "ປິດ",
    "globalSettings.retentionDays": "ເກັບໄວ້ (ວັນ)",
    "globalSettings.running": "ກຳລັງເຮັດວຽກ…",
    "globalSettings.backupNow": "ສຳຮອງດຽວນີ້",
    "globalSettings.recentBackups": "ການສຳຮອງຫຼ້າສຸດ",
    "globalSettings.restoreBackup": "ກູ້ຄືນຈາກການສຳຮອງນີ້",
    "globalSettings.defaults": "ຄ່າເລີ່ມຕົ້ນ",
    "globalSettings.defaultCurrency": "ສະກຸນເງິນເລີ່ມຕົ້ນ",
    "globalSettings.defaultTaxRate": "ອັດຕາພາສີເລີ່ມຕົ້ນ (%)",
    "globalSettings.locale": "ພາສາ/ພື້ນທີ່",
    "globalSettings.localeLao": "ລາວ",
    "globalSettings.localeEnglish": "ອັງກິດ",
    "globalSettings.timezone": "ເຂດເວລາ",
    "globalSettings.taxMode": "ໂໝດພາສີ",
    "globalSettings.taxInclusive": "ລວມພາສີ",
    "globalSettings.taxExclusive": "ບໍ່ລວມພາສີ",
    "globalSettings.lowStockThreshold": "ຂີດເຕືອນສິນຄ້າເຫຼືອໜ້ອຍ",
    "globalSettings.varianceThreshold": "ຂີດຜົນຕ່າງລິ້ນຊັກ (₭)",
    "globalSettings.varianceHintPrefix": "ຮອບວຽກທີ່ປິດແລ້ວມີຜົນຕ່າງເກີນ",
    "globalSettings.varianceHintSuffix": "ຈະແຈ້ງເຕືອນ.",
    "globalSettings.license": "ໃບອະນຸຍາດ",
    "globalSettings.plan": "ແພັກເກດ",
    "globalSettings.seatsUsed": "ສິດທິທີ່ໃຊ້",
    "globalSettings.seats": "ສິດທິ",
    "globalSettings.expires": "ໝົດອາຍຸ",
    "globalSettings.manageLicense": "ຈັດການໃບອະນຸຍາດ",
    "globalSettings.activating": "ກຳລັງເປີດໃຊ້…",
    "globalSettings.activate": "ເປີດໃຊ້",
    "globalSettings.licenseKey": "ລະຫັດໃບອະນຸຍາດ",
    "globalSettings.licenseActivated": "ເປີດໃຊ້ໃບອະນຸຍາດແລ້ວ.",
    "globalSettings.backupKindManual": "ດ້ວຍມື",
    "globalSettings.backupKindAuto": "ອັດຕະໂນມັດ",
    "globalSettings.backupStatusOk": "ສຳເລັດ",
    "globalSettings.backupStatusRunning": "ກຳລັງເຮັດ",
    "globalSettings.backupStatusFailed": "ລົ້ມເຫຼວ",
    "globalSettings.licenseTierTrial": "ທົດລອງ",
    "globalSettings.licenseTierBasic": "ພື້ນຖານ",
    "globalSettings.licenseTierPro": "ມືອາຊີບ",
    "globalSettings.licenseStateValid": "ມີໃບອະນຸຍາດ",
    "globalSettings.licenseStateTrial": "ທົດລອງ",
    "globalSettings.licenseStateInvalid": "ບໍ່ຖືກຕ້ອງ",
    "globalSettings.licensedTo": "ອອກໃຫ້",
    "globalSettings.unlicensed": "ຍັງບໍ່ມີໃບອະນຸຍາດ (ທົດລອງ)",
    "globalSettings.tillsUsed": "ຈຸດຂາຍ",
    "globalSettings.supportEnds": "ສະໜັບສະໜູນຮອດ",
    // ---------- Reports tab labels ----------
    "reports.tab.salesSummary": "ສະຫຼຸບການຂາຍ",
    "reports.tab.topProducts": "ສິນຄ້າຂາຍດີ",
    "reports.tab.deadStock": "ສິນຄ້າຄ້າງສາງ",
    "reports.tab.cashierPerformance": "ປະສິດທິພາບພະນັກງານ",
    "reports.tab.profitMargin": "ກຳໄລຂັ້ນຕົ້ນ",
    "reports.tab.paymentMethods": "ວິທີຊຳລະ",
    "reports.tab.storeCompare": "ປຽບທຽບຮ້ານ",
    "reports.tab.stockCard": "ບັດສາງ",
    "reports.tab.vat": "ພາສີມູນຄ່າເພີ່ມ (VAT)",
    "reports.tab.arApAging": "ໜີ້ຄ້າງຮັບ ແລະ ໃບແຈ້ງໜີ້ຜູ້ສະໜອງ",
    "reports.loading": "ກຳລັງໂຫລດລາຍງານ…",
    "reports.exporting": "ກຳລັງສົ່ງອອກ…",
    "reports.lastNDays": "{n} ມື້ຜ່ານມາ",
    // ---------- Stores cards / form ----------
    "stores.subtitleStores": "ຮ້ານ",
    "stores.subtitleWarehouse": "ສາງ",
    "stores.subtitleActiveTills": "ໜ້າຂາຍທີ່ໃຊ້ງານ",
    "stores.statusActive": "ໃຊ້ງານ",
    "stores.statusOff": "ປິດ",
    "stores.colCurrency": "ສະກຸນເງິນ",
    "stores.colTaxRate": "ອັດຕາພາສີ",
    "stores.colTimezone": "ເຂດເວລາ",
    "stores.taxIncl": "ລວມພາສີ",
    "stores.taxExcl": "ບໍ່ລວມພາສີ",
    "stores.dailyPrefix": "ປະຈຳວັນ",
    "stores.weekdayPrefix": "ຈັນ-ເສົາ",
    "stores.closedSuffix": "ປິດ",
    "stores.daysPerWeek": "ມື້/ອາທິດ",
    "stores.closedAllWeek": "ປິດໝົດອາທິດ",
    "stores.storeStaffLabel": "ພະນັກງານຂອງຮ້ານ",
    "stores.storeStaffUnavailable": "ພະນັກງານຂອງຮ້ານ (ຍັງບໍ່ພ້ອມ)",
    "stores.storeReportLabel": "ລາຍງານຂອງຮ້ານ",
    "stores.storeReportUnavailable": "ລາຍງານຂອງຮ້ານ (ຍັງບໍ່ພ້ອມ)",
    "stores.newStore": "ຮ້ານໃໝ່",
    "stores.editStorePrefix": "ແກ້ໄຂຮ້ານ —",
    "stores.fieldName": "ຊື່",
    "stores.fieldTimezone": "ເຂດເວລາ",
    "stores.fieldCurrency": "ສະກຸນເງິນ",
    "stores.fieldTaxRate": "ອັດຕາພາສີ %",
    "stores.fieldTaxMode": "ໂໝດພາສີ",
    "stores.fieldLanguage": "ພາສາເລີ່ມຕົ້ນ",
    "stores.fieldAddress": "ທີ່ຢູ່",
    "stores.fieldReceiptHeader": "ຫົວໃບບິນ",
    "stores.fieldReceiptFooter": "ທ້າຍໃບບິນ",
    "stores.fieldOpeningHours": "ເວລາເປີດ",
    "stores.taxInclusiveOption": "ລວມພາສີ",
    "stores.taxExclusiveOption": "ບໍ່ລວມພາສີ",
    "stores.langLao": "ລາວ",
    "stores.langEnglish": "ອັງກິດ",
    "stores.dayClosedLabel": "ປິດ",
    "stores.openDayLabel": "ເປີດ",
    "stores.closeDayLabel": "ປິດ",
    "stores.openDayTitle": "ເປີດມື້ນີ້",
    "stores.closeDayTitle": "ປິດມື້ນີ້",
    "stores.saving": "ກຳລັງບັນທຶກ…",
    "stores.dayMon": "ຈັນ",
    "stores.dayTue": "ອັງຄານ",
    "stores.dayWed": "ພຸດ",
    "stores.dayThu": "ພະຫັດ",
    "stores.dayFri": "ສຸກ",
    "stores.daySat": "ເສົາ",
    "stores.daySun": "ອາທິດ",
    // ---------- Staff (users) cards / table ----------
    "staff.subtitleUsers": "ຜູ້ໃຊ້",
    "staff.subtitleActive": "ໃຊ້ງານ",
    "staff.allRoles": "ບົດບາດທັງໝົດ",
    "staff.roleOwner": "ເຈົ້າຂອງ",
    "staff.roleManager": "ຜູ້ຈັດການ",
    "staff.roleCashier": "ພະນັກງານເກັບເງິນ",
    "staff.ownerGlobalHint": "ເຈົ້າຂອງມີສິດເຂົ້າເຖິງທຸກຮ້ານ ແລະ ການຕັ້ງຄ່າທັງໝົດ — ບໍ່ຈຳເປັນຕ້ອງມອບໝາຍຮ້ານ.",
    "staff.colLastLogin": "ເຂົ້າສູ່ລະບົບຄັ້ງລ່າສຸດ",
    "staff.colActive": "ໃຊ້ງານ",
    "staff.statusOn": "ເປີດ",
    "staff.statusOff": "ປິດ",
    "staff.resetPasswordLabel": "ຣີເຊັດລະຫັດຜ່ານ",
    "staff.editUserLabel": "ແກ້ໄຂຜູ້ໃຊ້",
    "staff.saving": "ກຳລັງບັນທຶກ…",
    "staff.allStoresLabel": "ທຸກຮ້ານ",
    "staff.editTitlePrefix": "ແກ້ໄຂ —",
    "staff.passwordTitlePrefix": "ຣີເຊັດລະຫັດຜ່ານ —",
    "staff.passwordTitleDefault": "ຣີເຊັດລະຫັດຜ່ານ",
    "staff.setPassword": "ຕັ້ງລະຫັດຜ່ານ",
    "staff.passwordMinError": "ລະຫັດຜ່ານຕ້ອງມີຢ່າງໜ້ອຍ 8 ຕົວ",
    "staff.passwordTypeNewPrefix": "ພິມລະຫັດຜ່ານໃໝ່ສຳລັບ",
    "staff.passwordHandOff": "ມອບໃຫ້ດ້ວຍຕົນເອງ — ພວກເຮົາບໍ່ເກັບໄວ້ໃນຮູບແບບອ່ານໄດ້.",
    "staff.passwordPlaceholder": "ຢ່າງໜ້ອຍ 8 ຕົວ",
    "staff.thisUserFallback": "ຜູ້ໃຊ້ນີ້",
    // TODO_LO: Managers must be assigned to a specific store.
    "staff.managerStoreRequiredHint": "ຜູ້ຈັດການຕ້ອງຖືກກຳນົດໃຫ້ປະຈຳຮ້ານໃດໜຶ່ງ.",
    // TODO_LO: Save failed
    "staff.saveFailedPrefix": "ບັນທຶກບໍ່ສຳເລັດ",
    // ---------- Stock Count ----------
    "stockCount.noSession": "ບໍ່ມີຮອບການກວດນັບ",
    "stockCount.startNewHeading": "ເລີ່ມການກວດນັບສາງໃໝ່",
    "stockCount.startNewDescription": "ໂຫລດທຸກສິນຄ້າທີ່ໃຊ້ງານໃນຮ້ານທີ່ເລືອກພ້ອມຈຳນວນຄາດໄວ້. ສະແກນແຕ່ລະອັນເພື່ອບັນທຶກຈຳນວນຕົວຈິງ.",
    "stockCount.sessionPrefix": "ຮອບ",
    "stockCount.sessionStartedPrefix": "ເລີ່ມເມື່ອ",
    "stockCount.sessionByPrefix": "ໂດຍ",
    "stockCount.statusDraft": "ຮ່າງ",
    "stockCount.statusInProgress": "ກຳລັງດຳເນີນ",
    "stockCount.statusSubmitted": "ສົ່ງແລ້ວ — ລໍຖ້າອະນຸມັດ",
    "stockCount.statusApproved": "ອະນຸມັດແລ້ວ",
    "stockCount.statusCancelled": "ຍົກເລີກ",
    "stockCount.pause": "ຢຸດຊົ່ວຄາວ",
    "stockCount.submitting": "ກຳລັງສົ່ງ…",
    "stockCount.closeAndPost": "ປິດການນັບ ແລະ ບັນທຶກ",
    "stockCount.approve": "ອະນຸມັດ",
    "stockCount.approving": "ກຳລັງອະນຸມັດ…",
    "stockCount.kpiItemsCounted": "ສິນຄ້ານັບແລ້ວ",
    "stockCount.kpiDifferences": "ຜົນຕ່າງ",
    "stockCount.kpiValueDiff": "ມູນຄ່າຜົນຕ່າງ",
    "stockCount.kpiDuration": "ໄລຍະເວລາ",
    "stockCount.scanPlaceholder": "ສະແກນບາໂຄດເພື່ອນັບ…",
    "stockCount.manualEntry": "ປ້ອນດ້ວຍມື",
    "stockCount.manualEntryLabel": "ປ້ອນການກວດນັບດ້ວຍມືຕາມ SKU",
    "stockCount.colDifference": "ຜົນຕ່າງ",
    "stockCount.colStatus": "ສະຖານະ",
    "stockCount.statusPending": "ລໍຖ້າ",
    "stockCount.statusOk": "ຖືກຕ້ອງ",
    "stockCount.statusDifference": "ມີຜົນຕ່າງ",
    "stockCount.starting": "ກຳລັງເລີ່ມ…",
    "stockCount.confirmStartPrefix": "ເລີ່ມການກວດນັບສາງໃໝ່ໃຫ້",
    "stockCount.confirmStartSuffix": "ບໍ? ທ່ານຕ້ອງສະແກນສິນຄ້າເພື່ອບັນທຶກຈຳນວນຕົວຈິງ.",
    // ---------- Stock by Store ----------
    "stockByStore.subtitleProducts": "ສິນຄ້າ",
    "stockByStore.lowStockOnly": "ສະເພາະສິນຄ້າເຫຼືອໜ້ອຍ",
    "stockByStore.startCount": "ເລີ່ມການກວດນັບ",
    "stockByStore.colProductHdr": "ສິນຄ້າ",
    "stockByStore.colSkuHdr": "SKU",
    "stockByStore.colTotalHdr": "ລວມ",
    "stockByStore.colValueHdr": "ມູນຄ່າ",
    "stockByStore.adjustTitlePrefix": "ປັບສາງ —",
    "stockByStore.adjustTitleDefault": "ປັບສາງ",
    "stockByStore.applyAdjustment": "ບັນທຶກການປັບ",
    "stockByStore.currentQty": "ຈຳນວນປະຈຸບັນ:",
    "stockByStore.delta": "ປ່ຽນແປງ (±)",
    "stockByStore.deltaPlaceholder": "ຕົວຢ່າງ: -3 ສຳລັບເສຍຫາຍ, +10 ສຳລັບພົບເພີ່ມ",
    "stockByStore.newQty": "ຈຳນວນໃໝ່:",
    "stockByStore.reason": "ເຫດຜົນ",
    "stockByStore.reasonDamage": "ເສຍຫາຍ",
    "stockByStore.reasonTheft": "ຖືກລັກ",
    "stockByStore.reasonCount": "ປັບຕາມການກວດນັບ",
    "stockByStore.reasonFound": "ພົບເພີ່ມ",
    "stockByStore.reasonInitial": "ສາງເລີ່ມຕົ້ນ",
    "stockByStore.reasonOther": "ອື່ນໆ",
    "stockByStore.noteOptional": "ບັນທຶກ (ບໍ່ບັງຄັບ)",
    "stockByStore.notePlaceholder": "ຕົວຢ່າງ: 'ກ່ອງຕົກ, 3 ຕຸກແຕກ'",
    "stockByStore.saving": "ກຳລັງບັນທຶກ…",
    // ---------- Transfers ----------
    "transfers.subtitleMovements": "ການເຄື່ອນໄຫວສິນຄ້າລະຫວ່າງຮ້ານ",
    "transfers.subtitleOutgoing": "ສົ່ງອອກ",
    "transfers.subtitleIncoming": "ຮັບເຂົ້າ",
    "transfers.statusDraft": "ຮ່າງ",
    "transfers.statusSent": "ສົ່ງແລ້ວ",
    "transfers.statusInTransit": "ກຳລັງສົ່ງ",
    "transfers.statusReceived": "ຮັບແລ້ວ",
    "transfers.statusCancelled": "ຍົກເລີກ",
    "transfers.outgoing": "ສົ່ງອອກ",
    "transfers.incoming": "ຮັບເຂົ້າ",
    "transfers.fromPrefix": "ຈາກ",
    "transfers.toPrefix": "ໄປ",
    "transfers.toArrow": "→",
    "transfers.noOutgoing": "ບໍ່ມີການໂອນສົ່ງອອກ.",
    "transfers.noIncoming": "ບໍ່ມີການໂອນຮັບເຂົ້າ.",
    "transfers.colValue": "ມູນຄ່າ",
    "transfers.colSent": "ສົ່ງເມື່ອ",
    "transfers.colReceived": "ຮັບເມື່ອ",
    "transfers.send": "ສົ່ງ",
    "transfers.cancelLabel": "ຍົກເລີກ",
    "transfers.receive": "ຮັບ",
    "transfers.confirmReceipt": "ຢືນຢັນການຮັບ",
    "transfers.saving": "ກຳລັງບັນທຶກ…",
    "transfers.receiveTitlePrefix": "ຮັບ —",
    "transfers.receiveTitleDefault": "ຮັບການໂອນ",
    "transfers.from": "ຈາກ",
    "transfers.to": "ໄປ",
    "transfers.sentLabel": "ສົ່ງເມື່ອ",
    "transfers.colSku": "SKU",
    "transfers.colProduct": "ສິນຄ້າ",
    "transfers.colQtySent": "ສົ່ງ",
    "transfers.colQtyReceived": "ຮັບ",
    "transfers.colDifference": "ຜົນຕ່າງ",
    "transfers.diffNotePlaceholder": "ບັນທຶກ (ບໍ່ບັງຄັບ) — ຕົວຢ່າງ: 2 ກ່ອງເສຍຫາຍລະຫວ່າງສົ່ງ",
    "transfers.diffWarning": "ລາຍການທີ່ມີຜົນຕ່າງຈະຖືກໝາຍໄວ້ໃຫ້ກວດການຂາຍ.",
    "transfers.newProductsHeading": "ສິນຄ້າ",
    "transfers.addProduct": "ເພີ່ມສິນຄ້າ",
    "transfers.noProductsYet": "ຍັງບໍ່ໄດ້ເພີ່ມສິນຄ້າ.",
    "transfers.colUnitCost": "ຕົ້ນທຶນຕໍ່ໜ່ວຍ",
    "transfers.colQty": "ຈຳນວນ",
    "transfers.colTotal": "ລວມ",
    "transfers.colLineTotal": "ລວມລາຍການ",
    "transfers.sourceStore": "ຮ້ານຕົ້ນທາງ",
    "transfers.destStore": "ຮ້ານປາຍທາງ",
    "transfers.selectStore": "ເລືອກ...",
    "transfers.lines": "ລາຍການ",
    "transfers.totalQty": "ຈຳນວນລວມ",
    "transfers.value": "ມູນຄ່າ",
    "transfers.notes": "ໝາຍເຫດ",
    "transfers.notesPlaceholder": "ໝາຍເຫດພາຍໃນສຳລັບການໂອນນີ້",
    "transfers.saveDraft": "ບັນທຶກຮ່າງ",
    "transfers.saveChanges": "ບັນທຶກການປ່ຽນແປງ",
    "transfers.editDraftPrefix": "ແກ້ໄຂຮ່າງ -",
    "transfers.removePrefix": "ລຶບ",
    "transfers.formChooseStores": "ເລືອກຮ້ານຕົ້ນທາງ ແລະ ປາຍທາງ.",
    "transfers.formDistinctStores": "ຮ້ານຕົ້ນທາງ ແລະ ປາຍທາງຕ້ອງຕ່າງກັນ.",
    "transfers.formNeedLine": "ເພີ່ມຢ່າງໜ້ອຍໜຶ່ງສິນຄ້າທີ່ມີຈຳນວນຫຼາຍກວ່າສູນ.",
    "transfers.formNoNegativeCost": "ຕົ້ນທຶນຕໍ່ໜ່ວຍຫ້າມຕິດລົບ.",
    "transfers.byPrefix": "ໂດຍ",
    "transfers.detailCreated": "ສ້າງເມື່ອ",
    "transfers.detailNotes": "ໝາຍເຫດ",
    "transfers.noLineItems": "ບໍ່ມີລາຍການ.",
    // ---------- Receive Goods ----------
    "receiveGoods.newGrPrefix": "ໃບຮັບໃໝ່ ·",
    "receiveGoods.draftSuffix": "· ຮ່າງ",
    "receiveGoods.saveDraft": "ບັນທຶກຮ່າງ",
    "receiveGoods.savePrintLabels": "ບັນທຶກ ແລະ ພິມປ້າຍ",
    "receiveGoods.receiveAndPost": "ຮັບ ແລະ ບັນທຶກ",
    "receiveGoods.saving": "ກຳລັງບັນທຶກ…",
    "receiveGoods.posting": "ກຳລັງບັນທຶກ…",
    "receiveGoods.supplierSelect": "ເລືອກ…",
    "receiveGoods.purchaseOrder": "ໃບສັ່ງຊື້",
    "receiveGoods.poPlaceholder": "PO-0284 (ບໍ່ມີ PO)",
    "receiveGoods.receiveDate": "ວັນທີຮັບ",
    "receiveGoods.store": "ຮ້ານ",
    "receiveGoods.scanPlaceholder": "ສະແກນບາໂຄດເພື່ອເພີ່ມແຖວ…",
    "receiveGoods.noLines": "ຍັງບໍ່ມີລາຍການ. ສະແກນບາໂຄດ ຫຼື ກົດ ປ້ອນດ້ວຍມື.",
    "receiveGoods.colNo": "#",
    "receiveGoods.colProduct": "ສິນຄ້າ",
    "receiveGoods.colUnitCost": "ຕົ້ນທຶນຕໍ່ໜ່ວຍ",
    "receiveGoods.colLineTotal": "ລວມລາຍການ",
    "receiveGoods.internalNote": "ໝາຍເຫດພາຍໃນ",
    "receiveGoods.notePlaceholder": "ຕົວຢ່າງ: 2 ກ່ອງເສຍຫາຍຕອນສົ່ງ",
    "receiveGoods.lines": "ລາຍການ",
    "receiveGoods.totalQty": "ຈຳນວນລວມ",
    "receiveGoods.subtotal": "ລວມຍ່ອຍ",
    "receiveGoods.totalCost": "ຕົ້ນທຶນລວມ",
    "receiveGoods.recentPurchases": "ການຮັບສິນຄ້າຫຼ້າສຸດ",
    "receiveGoods.removeLinePrefix": "ລຶບແຖວ",
    "receiveGoods.statusReceived": "ຮັບແລ້ວ",
    "receiveGoods.statusDraft": "ຮ່າງ",
    "receiveGoods.statusPosted": "ບັນທຶກແລ້ວ",
    "receiveGoods.statusPartial": "ບາງສ່ວນ",
    "receiveGoods.statusCancelled": "ຍົກເລີກ",
    // ---------- Stock Movements ----------
    "stockMovements.subtitleEvents": "ເຫດການມື້ນີ້",
    "stockMovements.allTypes": "ປະເພດທັງໝົດ",
    "stockMovements.allProducts": "ສິນຄ້າທັງໝົດ",
    "stockMovements.typeSale": "ການຂາຍ",
    "stockMovements.typeReturn": "ການຄືນ",
    "stockMovements.typeReceive": "ການຮັບ",
    "stockMovements.typeAdjust": "ການປັບ",
    "stockMovements.typeTransferIn": "ໂອນເຂົ້າ",
    "stockMovements.typeTransferOut": "ໂອນອອກ",
    "stockMovements.typeWaste": "ສູນເສຍ",
    "stockMovements.typeCountAdjust": "ປັບຕາມການນັບ",
    "stockMovements.actionSold": "ຂາຍ",
    "stockMovements.actionReturned": "ຄືນ",
    "stockMovements.actionReceived": "ຮັບ",
    "stockMovements.actionAdjusted": "ປັບ",
    "stockMovements.actionTransferIn": "ໂອນເຂົ້າ",
    "stockMovements.actionTransferOut": "ໂອນອອກ",
    "stockMovements.actionWasted": "ສູນເສຍ",
    "stockMovements.actionCountAdjust": "ປັບຕາມການນັບ",
    "stockMovements.pillSale": "ຂາຍ",
    "stockMovements.pillReturn": "ຄືນ",
    "stockMovements.pillReceive": "ຮັບ",
    "stockMovements.pillAdjust": "ປັບ",
    "stockMovements.pillTransferIn": "ໂອນເຂົ້າ",
    "stockMovements.pillTransferOut": "ໂອນອອກ",
    "stockMovements.pillWaste": "ສູນເສຍ",
    "stockMovements.pillCountAdjust": "ປັບຕາມການນັບ",
    "stockMovements.dateRangeSep": "ຮອດ",
    "stockMovements.loadMore": "ໂຫລດເພີ່ມ",
    // ---------- Dashboard ----------
    "dashboard.perStoreShift": "ສະຖານະຮອບວຽກຕາມຮ້ານ",
    "dashboard.shiftOpen": "ເປີດ",
    "dashboard.shiftClosed": "ປິດ",
    "dashboard.sinceLabel": "ຕັ້ງແຕ່",
    "dashboard.openSaleReviews": "ການກວດການຂາຍທີ່ຍັງເປີດ",
    "dashboard.review": "ກວດສອບ",
    "dashboard.top5Products": "ສິນຄ້າຂາຍດີ 5 ອັນດັບມື້ນີ້",
    "dashboard.top5Cashiers": "ພະນັກງານຂາຍດີ 5 ອັນດັບມື້ນີ້",
    "dashboard.lowStockAlerts": "ການແຈ້ງເຕືອນສິນຄ້າເຫຼືອໜ້ອຍ",
    "dashboard.revenuePrefix": "ລາຍຮັບ —",
    "dashboard.revenueTotal": "ລວມ:",
    "dashboard.hourLabel": "ຊົ່ວໂມງ",
    "dashboard.dayLabel": "ມື້",
    "dashboard.withSalesSuffix": "ທີ່ມີການຂາຍ",
    "dashboard.period24h": "24 ຊມ",
    "dashboard.period7d": "7 ມື້",
    "dashboard.period30d": "30 ມື້",
    "dashboard.period90d": "90 ມື້",
    "dashboard.periodCustom": "ກຳນົດເອງ",
    "dashboard.subtitleToday": "ມື້ນີ້ (ລາຍຊົ່ວໂມງ)",
    "dashboard.subtitle7d": "7 ມື້ຜ່ານມາ",
    "dashboard.subtitle30d": "30 ມື້ຜ່ານມາ",
    "dashboard.subtitle90d": "90 ມື້ຜ່ານມາ",
    "dashboard.subtitleCustom": "ໄລຍະທີ່ກຳນົດເອງ",
    "dashboard.hourly": "ລາຍຊົ່ວໂມງ",
    "dashboard.from": "ຈາກ",
    "dashboard.to": "ຮອດ",
    "dashboard.bucket": "ໜ່ວຍ",
    "dashboard.bucketHour": "ຊົ່ວໂມງ",
    "dashboard.bucketDay": "ມື້",
    "dashboard.hourlyHint": "ໜ່ວຍຊົ່ວໂມງໃຊ້ໄດ້ສະເພາະໄລຍະ ≤ 14 ມື້.",
    "dashboard.tooltipRevenue": "ລາຍຮັບ:",
    "dashboard.kpiTransactions": "ການເຮັດທຸລະກຳ",
    // ---------- SalesHistory ----------
    "salesHistory.subtitleSale": "ການຂາຍໃນຊ່ວງເວລາ",
    "salesHistory.subtitleSales": "ການຂາຍໃນຊ່ວງເວລາ",
    "salesHistory.walkIn": "ລູກຄ້າທົ່ວໄປ",
    "salesHistory.allTenders": "ການຊຳລະທັງໝົດ",
    "salesHistory.tenderCash": "ເງິນສົດ",
    "salesHistory.tenderQr": "QR",
    "salesHistory.tenderCard": "ບັດ",
    "salesHistory.tenderCredit": "ເຄຣດິດ",
    "salesHistory.tenderSplit": "ແບ່ງຈ່າຍ",
    "salesHistory.statusPaid": "ຈ່າຍແລ້ວ",
    "salesHistory.statusVoided": "ຍົກເລີກ",
    "salesHistory.statusRefund": "ຄືນເງິນ",
    "salesHistory.rangeAll": "ທັງໝົດ",
    "salesHistory.rangeToday": "ມື້ນີ້",
    "salesHistory.range7d": "7 ມື້",
    "salesHistory.range30d": "30 ມື້",
    "salesHistory.rangeCustom": "ກຳນົດເອງ…",
    "salesHistory.colReceiptHdr": "ເລກບິນ",
    "salesHistory.colTimeHdr": "ເວລາ",
    "salesHistory.colTenderHdr": "ການຊຳລະ",
    "salesHistory.colReferenceHdr": "ເລກອ້າງອີງ",
    "salesHistory.colCustomerHdr": "ລູກຄ້າ",
    "salesHistory.colCashierHdr": "ພະນັກງານ",
    "salesHistory.colTotalHdr": "ລວມ",
    "salesHistory.colStatusHdr": "ສະຖານະ",
    "salesHistory.saleDetail": "ລາຍລະອຽດການຂາຍ",
    "salesHistory.closeDrawer": "ປິດແຖບ",
    "salesHistory.voidSale": "ຍົກເລີກບິນ",
    "salesHistory.requestVoid": "ຂໍຍົກເລີກບິນ",
    "salesHistory.voidConfirmBody": "ສິນຄ້າຈະກັບຄືນສະຕັອກ ແລະ ບິນນີ້ຈະຖືກລຶບອອກຈາກລາຍຮັບ. ບໍ່ສາມາດຍ້ອນກັບໄດ້.",
    "salesHistory.voidReasonLabel": "ເຫດຜົນ (ຈຳເປັນ)",
    "salesHistory.voidReasonPlaceholder": "ຍ້ອນຫຍັງຈຶ່ງຍົກເລີກບິນນີ້?",
    // ---------- Conflicts ----------
    "conflicts.subtitleWaiting": "ລໍຖ້າ",
    "conflicts.subtitleHint": "ການຂາຍທີ່ເຊີບເວີຄືນຫຼັງຊິ້ງ",
    "conflicts.acceptAllSimilar": "ຮັບເອົາທັງໝົດທີ່ຄ້າຍກັນ",
    "conflicts.kpiOpen": "ເປີດ",
    "conflicts.kpiResolved7d": "ແກ້ໄຂແລ້ວ (7 ມື້)",
    "conflicts.kpiValueAtRisk": "ມູນຄ່າທີ່ສ່ຽງ",
    "conflicts.kpiAvgResolution": "ເວລາແກ້ໄຂສະເລ່ຍ",
    "conflicts.filterAll": "ທັງໝົດ",
    "conflicts.filterOpen": "ເປີດ",
    "conflicts.filterAccepted": "ຮັບເອົາ",
    "conflicts.filterBackordered": "ສັ່ງຄືນ",
    "conflicts.filterCancelled": "ຍົກເລີກ",
    "conflicts.statusNeedsReview": "ຕ້ອງກວດ",
    "conflicts.statusAccepted": "ຮັບເອົາແລ້ວ",
    "conflicts.statusCancelled": "ຍົກເລີກແລ້ວ",
    "conflicts.statusBackordered": "ສັ່ງຄືນແລ້ວ",
    "conflicts.acceptAsIs": "ຮັບເອົາຕາມເດີມ",
    "conflicts.backorder": "ສັ່ງຄືນ",
    "conflicts.cancelRefund": "ຍົກເລີກ / ຄືນເງິນ",
    "conflicts.nothingToReview": "ບໍ່ມີຫຍັງໃຫ້ກວດສອບ. ການຂາຍທັງໝົດຖືກຊຳລະແລ້ວ.",
    "conflicts.resolvedHistory": "ປະຫວັດການແກ້ໄຂ",
    "conflicts.colId": "ລະຫັດ",
    "conflicts.colProduct": "ສິນຄ້າ",
    "conflicts.colResolution": "ການແກ້ໄຂ",
    "conflicts.colResolved": "ແກ້ໄຂເມື່ອ",
    "conflicts.colAmount": "ຈຳນວນເງິນ",
    "conflicts.colNote": "ໝາຍເຫດ",
    // ---------- Shifts & Drawers ----------
    "shiftsDrawers.subtitleShifts": "ຮອບວຽກໃນຊ່ວງເວລາ",
    "shiftsDrawers.subtitleOpen": "ເປີດ",
    "shiftsDrawers.subtitleClosed": "ປິດ",
    "shiftsDrawers.subtitleTotalDiff": "ຜົນຕ່າງລວມ",
    "shiftsDrawers.last7Days": "7 ມື້ຜ່ານມາ",
    "shiftsDrawers.rangeToday": "ມື້ນີ້",
    "shiftsDrawers.rangeLast30Days": "30 ມື້ຜ່ານມາ",
    "shiftsDrawers.rangeAllTime": "ທັງໝົດ",
    "shiftsDrawers.rangeCustom": "ກຳນົດເອງ…",
    "shiftsDrawers.colShift": "ຮອບ",
    "shiftsDrawers.colOpenedBy": "ເປີດໂດຍ",
    "shiftsDrawers.colClosedBy": "ປິດໂດຍ",
    "shiftsDrawers.colOpened": "ເປີດເມື່ອ",
    "shiftsDrawers.colOpening": "ເງິນເລີ່ມຕົ້ນ",
    "shiftsDrawers.colExpectedHdr": "ຄາດໄວ້",
    "shiftsDrawers.colCountedHdr": "ນັບໄດ້",
    "shiftsDrawers.colDifference": "ຜົນຕ່າງ",
    "shiftsDrawers.colStatus": "ສະຖານະ",
    "shiftsDrawers.shiftOpen": "ເປີດ",
    "shiftsDrawers.shiftClosed": "ປິດ",
    "shiftsDrawers.drawerOpenLog": "ບັນທຶກການເປີດລິ້ນຊັກ",
    "shiftsDrawers.eventsCount": "ເຫດການ",
    "shiftsDrawers.drawerColTime": "ເວລາ",
    "shiftsDrawers.drawerColCashier": "ພະນັກງານ",
    "shiftsDrawers.drawerColReason": "ເຫດຜົນ",
    "shiftsDrawers.drawerColContext": "ບໍລິບົດ",
    "shiftsDrawers.reasonSale": "ການຂາຍ",
    "shiftsDrawers.reasonManual": "ດ້ວຍມື",
    "shiftsDrawers.reasonDrop": "ນຳເງິນອອກ",
    "shiftsDrawers.reasonCount": "ນັບເງິນ",
    "shiftsDrawers.antiTheft": "ການແຈ້ງເຕືອນປ້ອງກັນຂະໂມຍ",
    "shiftsDrawers.noFlags": "ບໍ່ມີການແຈ້ງເຕືອນໃນຊ່ວງເວລານີ້.",
    "shiftsDrawers.severityHigh": "ສູງ",
    "shiftsDrawers.severityWatch": "ຕ້ອງເຝົ້າເບິ່ງ",
    "shiftsDrawers.diff7d": "ຜົນຕ່າງ — 7 ມື້",
    "shiftsDrawers.net": "ສຸດທິ",
    // ---------- Expenses ----------
    "expenses.subtitleMonthly": "ບັນຊີລາຍເດືອນ",
    "expenses.subtitleEntries": "ລາຍການ",
    "expenses.subtitleTotal": "ລວມ",
    "expenses.colIdHdr": "ລະຫັດ",
    "expenses.colDateHdr": "ວັນທີ",
    "expenses.colCategoryHdr": "ໝວດໝູ່",
    "expenses.colDescriptionHdr": "ລາຍລະອຽດ",
    "expenses.colAmountHdr": "ຈຳນວນເງິນ",
    "expenses.colRecordedBy": "ບັນທຶກໂດຍ",
    "expenses.colReceipt": "ໃບບິນ",
    "expenses.downloadReceipt": "ດາວໂຫລດໃບບິນສຳລັບ",
    "expenses.kpiOther": "ອື່ນໆ",
    "expenses.entry": "ລາຍການ",
    "expenses.entries": "ລາຍການ",
    "expenses.totalLabel": "ລວມ",
    "expenses.dateRangeSep": "ຮອດ",
    // ---------- Sync Queue ----------
    "syncQueue.title": "ຄິວຊິ້ງຂໍ້ມູນ",
    "syncQueue.subtitleTotal": "ທັງໝົດ",
    "syncQueue.subtitleError": "ຜິດພາດ",
    "syncQueue.subtitlePending": "ລໍຖ້າ",
    "syncQueue.refresh": "ໂຫລດຄືນ",
    "syncQueue.clearSynced": "ລ້າງທີ່ຊິ້ງແລ້ວ",
    "syncQueue.kpiPending": "ລໍຖ້າ",
    "syncQueue.kpiError": "ຜິດພາດ",
    "syncQueue.kpiNeedsReview": "ຕ້ອງກວດ",
    "syncQueue.kpiSynced": "ຊິ້ງແລ້ວ",
    "syncQueue.errorsByMessage": "ຂໍ້ຜິດພາດຈັດກຸ່ມຕາມຂໍ້ຄວາມ",
    "syncQueue.discardAll": "ຍົກເລີກທັງໝົດ",
    "syncQueue.filterAll": "ທັງໝົດ",
    "syncQueue.filterError": "ຜິດພາດ",
    "syncQueue.filterPending": "ລໍຖ້າ",
    "syncQueue.filterNeedsReview": "ຕ້ອງກວດ",
    "syncQueue.filterSynced": "ຊິ້ງແລ້ວ",
    "syncQueue.allTypes": "ປະເພດທັງໝົດ",
    "syncQueue.typeSaleCreate": "ການຂາຍ (ສ້າງ)",
    "syncQueue.typeSaleVoid": "ການຂາຍ (ຍົກເລີກ)",
    "syncQueue.typeStockAdjust": "ປັບສາງ",
    "syncQueue.typeDrawerOpen": "ເປີດລິ້ນຊັກ",
    "syncQueue.typeDrawerClose": "ປິດລິ້ນຊັກ",
    "syncQueue.typeDrawerMovement": "ການເຄື່ອນໄຫວລິ້ນຊັກ",
    "syncQueue.typeExpenseCreate": "ລາຍຈ່າຍ",
    "syncQueue.typeHeldOrderSave": "ບິນຄ້າງ (ບັນທຶກ)",
    "syncQueue.typeHeldOrderCancel": "ບິນຄ້າງ (ຍົກເລີກ)",
    "syncQueue.statusPending": "ລໍຖ້າ",
    "syncQueue.statusSynced": "ຊິ້ງແລ້ວ",
    "syncQueue.statusNeedsReview": "ຕ້ອງກວດ",
    "syncQueue.statusError": "ຜິດພາດ",
    "syncQueue.searchPlaceholder": "ຄົ້ນຫາ ລະຫັດ, ຂໍ້ຄວາມ, payload…",
    "syncQueue.failedToLoad": "ໂຫລດບໍ່ສຳເລັດ:",
    "syncQueue.eventsPrefix": "ເຫດການ",
    "syncQueue.loading": "ກຳລັງໂຫລດ…",
    "syncQueue.noEvents": "ບໍ່ມີເຫດການທີ່ຕົງກັບການກັ່ນຕອງ.",
    "syncQueue.colId": "ລະຫັດ",
    "syncQueue.colType": "ປະເພດ",
    "syncQueue.colStatus": "ສະຖານະ",
    "syncQueue.colAttempts": "ຈຳນວນຄັ້ງ",
    "syncQueue.colCreated": "ສ້າງເມື່ອ",
    "syncQueue.colLastAttempt": "ລອງຫຼ້າສຸດ",
    "syncQueue.colMessage": "ຂໍ້ຄວາມເຊີບເວີ / payload",
    "syncQueue.colActions": "ການກະທຳ",
    "syncQueue.retry": "ລອງໃໝ່",
    "syncQueue.discard": "ຍົກເລີກ",
    "syncQueue.expandEventId": "ລະຫັດເຫດການ",
    "syncQueue.expandServerRes": "ຊັບພະຍາກອນເຊີບເວີ",
    "syncQueue.expandServerMsg": "ຂໍ້ຄວາມເຊີບເວີ",
    "syncQueue.expandPayload": "Payload",
    // ---------- Products ----------
    "products.subtitleActive": "ໃຊ້ງານ",
    "products.colProductHdr": "ສິນຄ້າ",
    "products.colIdHdr": "ລະຫັດ",
    "products.colBarcodeHdr": "ບາໂຄດ",
    "products.colCategoryHdr": "ໝວດໝູ່",
    "products.colBrandHdr": "ຍີ່ຫໍ້",
    "products.colCostHdr": "ຕົ້ນທຶນ",
    "products.colSellHdr": "ລາຄາຂາຍ",
    "products.colStockHdr": "ສາງ",
    "products.colStatusHdr": "ສະຖານະ",
    "products.statusActivePill": "ໃຊ້ງານ",
    "products.statusInactivePill": "ບໍ່ໃຊ້ງານ",
    "products.printLabels": "ພິມປ້າຍ",
    "products.filterAllStatuses": "ສະຖານະທັງໝົດ",
    "products.filterActive": "ໃຊ້ງານ",
    "products.filterInactive": "ບໍ່ໃຊ້ງານ",
    "products.selectedSuffix": "ທີ່ເລືອກ",
    "products.bulkPriceAdjust": "ປັບລາຄາ",
    "products.bulkActivate": "ເປີດໃຊ້",
    "products.bulkDeactivate": "ປິດໃຊ້",
    "products.bulkPrintLabels": "ພິມປ້າຍ",
    "products.selectAllPage": "ເລືອກທັງໝົດໃນໜ້ານີ້",
    "products.deselectAllPage": "ຍົກເລີກການເລືອກທັງໝົດ",
    "products.editAriaPrefix": "ແກ້ໄຂ",
    // ---------- Categories & Brands ----------
    "categoriesBrands.subtitle": "ໝວດໝູ່ແບບຕົ້ນໄມ້ · ຍີ່ຫໍ້ແບບແບນ",
    "categoriesBrands.newTopCategory": "ຊື່ໝວດໝູ່ລະດັບເທິງສຸດໃໝ່…",
    "categoriesBrands.newBrand": "ຊື່ຍີ່ຫໍ້ໃໝ່…",
    "categoriesBrands.brandHdr": "ຍີ່ຫໍ້",
    "categoriesBrands.productsHdr": "ສິນຄ້າ",
    "categoriesBrands.onHandValueHdr": "ມູນຄ່າໃນສາງ",
    "categoriesBrands.brandActive": "ໃຊ້ງານ",
    "categoriesBrands.brandInactive": "ບໍ່ໃຊ້ງານ",
    "categoriesBrands.subBadge": "ຍ່ອຍ",
    "categoriesBrands.collapse": "ຫຼຸບ",
    "categoriesBrands.expand": "ກາງອອກ",
    "categoriesBrands.moveUp": "ຍ້າຍຂຶ້ນ",
    "categoriesBrands.moveDown": "ຍ້າຍລົງ",
    "categoriesBrands.addSubCategory": "ເພີ່ມໝວດໝູ່ຍ່ອຍ",
    "categoriesBrands.rename": "ປ່ຽນຊື່",
    "categoriesBrands.deleteCategory": "ລຶບໝວດໝູ່",
    "categoriesBrands.renameBrand": "ປ່ຽນຊື່ຍີ່ຫໍ້",
    "categoriesBrands.deleteBrand": "ລຶບຍີ່ຫໍ້",
    "categoriesBrands.noCategories": "ຍັງບໍ່ມີໝວດໝູ່ — ເພີ່ມຂ້າງເທິງ.",
    "categoriesBrands.noBrands": "ຍັງບໍ່ມີຍີ່ຫໍ້.",
    "categoriesBrands.newSubCatTitle": "ໝວດໝູ່ຍ່ອຍໃໝ່",
    "categoriesBrands.cancel": "ຍົກເລີກ",
    "categoriesBrands.ok": "ຕົກລົງ",
    "categoriesBrands.subCatName": "ຊື່ໝວດໝູ່ຍ່ອຍ",
    "categoriesBrands.underPrefix": "· ພາຍໃຕ້",
    "categoriesBrands.subCatPlaceholder": "ຕົວຢ່າງ: ອາຫານງົວ",
    "categoriesBrands.deleteCatTitle": "ລຶບໝວດໝູ່",
    "categoriesBrands.deleteBrandTitle": "ລຶບຍີ່ຫໍ້",
    "categoriesBrands.deleteConfirm": "ລຶບ",
    "categoriesBrands.deleteCatBodyPrefix": "ລຶບໝວດໝູ່ “",
    "categoriesBrands.deleteCatBodySuffix": "”? ສິນຄ້າໃນໝວດໝູ່ນີ້ຈະບໍ່ມີໝວດໝູ່.",
    "categoriesBrands.deleteBrandBodyPrefix": "ລຶບຍີ່ຫໍ້ “",
    "categoriesBrands.deleteBrandBodySuffix": "”? ຈະປິດການໃຊ້ງານ.",
    // ---------- Promotions ----------
    "promotions.subtitleActive": "ໃຊ້ງານ",
    "promotions.subtitlePaused": "ຢຸດຊົ່ວຄາວ",
    "promotions.subtitleUsesMonth": "ການໃຊ້ໃນເດືອນນີ້",
    "promotions.filterAll": "ທັງໝົດ",
    "promotions.filterActive": "ໃຊ້ງານ",
    "promotions.filterPaused": "ຢຸດຊົ່ວຄາວ",
    "promotions.filterScheduled": "ກຳນົດໄວ້",
    "promotions.filterExpired": "ໝົດອາຍຸ",
    "promotions.statusActive": "ໃຊ້ງານ",
    "promotions.statusPaused": "ຢຸດຊົ່ວຄາວ",
    "promotions.statusScheduled": "ກຳນົດໄວ້",
    "promotions.statusExpired": "ໝົດອາຍຸ",
    "promotions.typePercentOffCat": "ສ່ວນຫຼຸດເປີເຊັນຕາມໝວດໝູ່",
    "promotions.typeAmountOffProd": "ສ່ວນຫຼຸດຈຳນວນຕາມສິນຄ້າ",
    "promotions.typeBuyXGetY": "ຊື້ X ໄດ້ Y",
    "promotions.typeBundlePrice": "ລາຄາແພັກ",
    "promotions.typeSpendThreshold": "ຂີດການໃຊ້ຈ່າຍ",
    "promotions.typeTimeWindow": "ຊ່ວງເວລາ",
    "promotions.colStartsHdr": "ເລີ່ມ",
    "promotions.colEndsHdr": "ສິ້ນສຸດ",
    "promotions.usesSuffix": "ການໃຊ້ໃນເດືອນນີ້",
    "promotions.liftSuffix": "ເພີ່ມຂຶ້ນ",
    "promotions.editLabel": "ແກ້ໄຂ",
    "promotions.resumeLabel": "ສືບຕໍ່",
    "promotions.pauseLabel": "ຢຸດຊົ່ວຄາວ",
    "promotions.deleteLabel": "ລຶບ",
    "promotions.previewOffSuffix": "ສ່ວນຫຼຸດ",
    "promotions.previewBuyPrefix": "ຊື້",
    "promotions.previewGetMiddle": "ໄດ້",
    "promotions.previewFreeSuffix": "ຟຣີ",
    "promotions.previewBundlePrefix": "ແພັກຂອງ",
    "promotions.previewItemsArrow": "ລາຍການ →",
    "promotions.previewSpendPrefix": "ໃຊ້ຈ່າຍ",
    "promotions.previewSpendGetSuffix": "ໄດ້",
    "promotions.previewPercentOff": "% ສ່ວນຫຼຸດ",
    // ---------- Customers ----------
    "customers.subtitleCustomers": "ລູກຄ້າ",
    "customers.subtitleOweMoney": "ລູກຄ້າຍັງຄ້າງເງິນ",
    "customers.subtitleLoyaltyYtd": "ຄະແນນສະສົມຂອງປີ",
    "customers.sendStatements": "ສົ່ງໃບແຈ້ງຍອດ",
    "customers.sendingPrefix": "ກຳລັງສົ່ງ",
    "customers.colNameHdr": "ຊື່",
    "customers.colPhoneHdr": "ເບີໂທ",
    "customers.colEmailHdr": "ອີເມວ",
    "customers.colTierHdr": "ລະດັບ",
    "customers.colBalanceHdr": "ເງິນທີ່ລູກຄ້າຍັງຄ້າງ",
    "customers.colCreditHdr": "ເຄຣດິດຮ້ານ",
    "customers.colPointsHdr": "ຄະແນນສະສົມ",
    "customers.colLastVisitHdr": "ມາຄັ້ງສຸດທ້າຍ",
    "customers.allTiers": "ທຸກລະດັບ",
    "customers.tierBronze": "ບຣອນ",
    "customers.tierSilver": "ເງິນ",
    "customers.tierGold": "ຄຳ",
    "customers.tierPlatinum": "ແພລດທິນຳ",
    "customers.tierDefault": "ເລີ່ມຕົ້ນ (ບຣອນ)",
    "customers.owesMoney": "ຄ້າງເງິນ",
    "customers.drawerCustomerLabel": "ລູກຄ້າ",
    "customers.closeDrawer": "ປິດ",
    "customers.kpiTotalSpend": "ການໃຊ້ຈ່າຍລວມ",
    "customers.kpiVisits": "ການມາຮ້ານ",
    "customers.kpiAvgTicket": "ຄ່າສະເລ່ຍຕໍ່ບິນ",
    "customers.kpiLoyaltyPts": "ຄະແນນສະສົມ",
    "customers.moneyOwedHeading": "ເງິນທີ່ລູກຄ້າຍັງຄ້າງ",
    "customers.deltaPlaceholder": "ປ່ຽນແປງ (±₭)",
    "customers.reasonPlaceholder": "ເຫດຜົນ",
    "customers.adjustCredit": "ປັບເຄຣດິດ",
    "customers.sendStatement": "ສົ່ງໃບແຈ້ງຍອດ",
    "customers.purchaseHistory": "ປະຫວັດການຊື້",
    "customers.salesCount": "ບິນ",
    "customers.noPurchases": "ຍັງບໍ່ມີການຊື້.",
    "customers.histReceipt": "ເລກບິນ",
    "customers.histDate": "ວັນທີ",
    "customers.histTotal": "ລວມ",
    "customers.histTender": "ການຊຳລະ",
    "customers.fieldName": "ຊື່",
    "customers.fieldPhone": "ເບີໂທ",
    "customers.fieldEmail": "ອີເມວ (ບໍ່ບັງຄັບ)",
    "customers.fieldTier": "ລະດັບ (ບໍ່ບັງຄັບ)",
    "customers.fieldNotes": "ໝາຍເຫດ (ບໍ່ບັງຄັບ)",
    "customers.fullNamePlaceholder": "ຊື່ເຕັມ",
    "customers.phonePlaceholder": "+856 20 …",
    "customers.emailPlaceholder": "name@example.la",
    "customers.notesPlaceholder": "ສິ່ງທີ່ພະນັກງານຄວນຮູ້",
    "customers.saving": "ກຳລັງບັນທຶກ…",
    // ---------- Suppliers ----------
    "suppliers.subtitleSuppliers": "ຜູ້ສະໜອງ",
    "suppliers.subtitleBillsToPay": "ໃບແຈ້ງໜີ້ຜູ້ສະໜອງທີ່ຕ້ອງຈ່າຍ",
    "suppliers.billsByAge": "ໃບແຈ້ງໜີ້ຕາມອາຍຸ",
    "suppliers.kpiBillsToPay": "ໃບແຈ້ງໜີ້ທີ່ຕ້ອງຈ່າຍ",
    "suppliers.kpiSuppliersWeOwe": "ຜູ້ສະໜອງທີ່ເຮົາຄ້າງ",
    "suppliers.kpiProductsSupplied": "ສິນຄ້າທີ່ສະໜອງ",
    "suppliers.kpiDue30": "ເກີນກຳນົດ > 30 ມື້",
    "suppliers.hasBillsToPay": "ມີໃບແຈ້ງໜີ້ຕ້ອງຈ່າຍ",
    "suppliers.colSupplierHdr": "ຜູ້ສະໜອງ",
    "suppliers.colContactHdr": "ຜູ້ຕິດຕໍ່",
    "suppliers.colPhoneHdr": "ເບີໂທ",
    "suppliers.colProductsHdr": "ສິນຄ້າ",
    "suppliers.colApHdr": "ໃບແຈ້ງໜີ້ທີ່ຕ້ອງຈ່າຍ",
    "suppliers.colLastHdr": "ສັ່ງຄັ້ງສຸດທ້າຍ",
    "suppliers.drawerSupplierLabel": "ຜູ້ສະໜອງ",
    "suppliers.closeDrawer": "ປິດ",
    "suppliers.kpiAvgOrder": "ການສັ່ງສະເລ່ຍ",
    "suppliers.kpiLastOrder": "ສັ່ງຄັ້ງສຸດທ້າຍ",
    "suppliers.billsByAgeSection": "ໃບແຈ້ງໜີ້ຕາມອາຍຸ",
    "suppliers.productsSupplied": "ສິນຄ້າທີ່ສະໜອງ",
    "suppliers.histProduct": "ສິນຄ້າ",
    "suppliers.histSku": "SKU",
    "suppliers.histUnitCost": "ຕົ້ນທຶນຕໍ່ໜ່ວຍ",
    "suppliers.noProductsLinked": "ບໍ່ມີສິນຄ້າທີ່ເຊື່ອມຕໍ່ກັບຜູ້ສະໜອງນີ້.",
    "suppliers.priceHistoryPrefix": "ປະຫວັດລາຄາ —",
    "suppliers.closeChart": "ປິດກຣາຟ",
    "suppliers.paySupplier": "ຈ່າຍຜູ້ສະໜອງ",
    "suppliers.amountPlaceholder": "ຈຳນວນເງິນ (₭)",
    "suppliers.recordPayment": "ບັນທຶກການຈ່າຍ",
    "suppliers.amountExceedsPrefix": "ຈຳນວນເງິນເກີນໃບແຈ້ງໜີ້ທີ່ຕ້ອງຈ່າຍ",
};
export default lo;
//# sourceMappingURL=lo.js.map